// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AbTestPromptsData, AbTestPromptsErrors, AbTestPromptsResponses, AcceptSummaryToolProposalData, AcceptSummaryToolProposalErrors, AcceptSummaryToolProposalResponses, AcceptTermsData, AcceptTermsErrors, AcceptTermsResponses, ActivatePromptVersionData, ActivatePromptVersionErrors, ActivatePromptVersionResponses, AddProjectMemberData, AddProjectMemberErrors, AddProjectMemberResponses, AddWorkspaceMemberData, AddWorkspaceMemberErrors, AddWorkspaceMemberResponses, AdjustCompanyPremiumSeatsData, AdjustCompanyPremiumSeatsErrors, AdjustCompanyPremiumSeatsResponses, AdminReset2FaData, AdminReset2FaErrors, AdminReset2FaResponses, AiHealthCheckData, AiHealthCheckResponses, ArchiveInterviewData, ArchiveInterviewErrors, ArchiveInterviewResponses, AssignCompanyLicenseData, AssignCompanyLicenseErrors, AssignCompanyLicenseResponses, AssignUserLicenseData, AssignUserLicenseErrors, AssignUserLicenseResponses, BulkDeleteArtifactsData, BulkDeleteArtifactsErrors, BulkDeleteArtifactsResponses, BulkResetTermsData, BulkResetTermsErrors, BulkResetTermsResponses, CeleryHealthCheckData, CeleryHealthCheckResponses, ChatStreamData, ChatStreamErrors, ChatStreamResponses, ClearSummaryChatHistoryData, ClearSummaryChatHistoryErrors, ClearSummaryChatHistoryResponses, ClonePromptForCompanyData, ClonePromptForCompanyErrors, ClonePromptForCompanyResponses, CompleteOnboardingData, CompleteOnboardingResponses, ConfirmPasswordResetData, ConfirmPasswordResetErrors, ConfirmPasswordResetResponses, ConfirmUploadData, ConfirmUploadErrors, ConfirmUploadResponses, ConvertLegacySummaryData, ConvertLegacySummaryErrors, ConvertLegacySummaryResponses, CreateAnalysisData, CreateAnalysisErrors, CreateAnalysisResponses, CreateAssignmentsData, CreateAssignmentsErrors, CreateAssignmentsResponses, CreateBulkUsersData, CreateBulkUsersErrors, CreateBulkUsersResponses, CreateCompanyData, CreateCompanyErrors, CreateCompanyResponses, CreateDocumentVersionData, CreateDocumentVersionErrors, CreateDocumentVersionResponses, CreateInterviewProcessData, CreateInterviewProcessErrors, CreateInterviewProcessResponses, CreateProjectData, CreateProjectErrors, CreateProjectResponses, CreatePromptVersionData, CreatePromptVersionErrors, CreatePromptVersionResponses, CreateSuperAdminData, CreateSuperAdminErrors, CreateSuperAdminResponses, CreateUserData, CreateUserErrors, CreateUserResponses, CreateWorkspaceData, CreateWorkspaceErrors, CreateWorkspaceResponses, DatabaseHealthCheckData, DatabaseHealthCheckResponses, DeactivatePromptVersionData, DeactivatePromptVersionErrors, DeactivatePromptVersionResponses, DeleteAnalysisData, DeleteAnalysisErrors, DeleteAnalysisResponses, DeleteArtifactData, DeleteArtifactErrors, DeleteArtifactResponses, DeleteAssignmentData, DeleteAssignmentErrors, DeleteAssignmentResponses, DeleteCompanyData, DeleteCompanyErrors, DeleteCompanyResponses, DeleteProjectData, DeleteProjectErrors, DeleteProjectResponses, DeleteUserData, DeleteUserErrors, DeleteUserResponses, DocumentProcessingRunsSummaryData, DocumentProcessingRunsSummaryErrors, DocumentProcessingRunsSummaryResponses, ExportModelToPptxData, ExportModelToPptxErrors, ExportModelToPptxResponses, ExportModelToVisioData, ExportModelToVisioErrors, ExportModelToVisioResponses, ExtendUserLicenseData, ExtendUserLicenseErrors, ExtendUserLicenseResponses, FlushDocumentCheckpointData, FlushDocumentCheckpointErrors, FlushDocumentCheckpointResponses, GenerateContentData, GenerateContentErrors, GenerateContentResponses, GenerateContentStreamData, GenerateContentStreamErrors, GenerateContentStreamResponses, GenerateModelData, GenerateModelErrors, GenerateModelResponses, GenerateRaciDeliverableData, GenerateRaciDeliverableErrors, GenerateRaciDeliverableResponses, GenerateRequirementsDeliverableData, GenerateRequirementsDeliverableErrors, GenerateRequirementsDeliverableResponses, GenerateSopDeliverableData, GenerateSopDeliverableErrors, GenerateSopDeliverableResponses, GenerateSummaryData, GenerateSummaryErrors, GenerateSummaryResponses, GenerateUserStoriesDeliverableData, GenerateUserStoriesDeliverableErrors, GenerateUserStoriesDeliverableResponses, GetAllCompaniesData, GetAllCompaniesResponses, GetAllUsersData, GetAllUsersResponses, GetAnalysisData, GetAnalysisErrors, GetAnalysisResponses, GetArtifactByIdData, GetArtifactByIdErrors, GetArtifactByIdResponses, GetArtifactsByProjectData, GetArtifactsByProjectErrors, GetArtifactsByProjectResponses, GetAssignmentData, GetAssignmentErrors, GetAssignmentResponses, GetCompanyBillingDetailsData, GetCompanyBillingDetailsErrors, GetCompanyBillingDetailsResponses, GetCompanyInfoData, GetCompanyInfoErrors, GetCompanyInfoResponses, GetCompanyLicenseData, GetCompanyLicenseErrors, GetCompanyLicenseResponses, GetCompanyLicensesBulkData, GetCompanyLicensesBulkErrors, GetCompanyLicensesBulkResponses, GetCompanyLicenseUsageData, GetCompanyLicenseUsageErrors, GetCompanyLicenseUsageResponses, GetCompanySsoChecklistData, GetCompanySsoChecklistErrors, GetCompanySsoChecklistResponses, GetCompanyUsersBulkData, GetCompanyUsersBulkErrors, GetCompanyUsersBulkResponses, GetCompanyUsersData, GetCompanyUsersErrors, GetCompanyUsersResponses, GetCurrentUserInfoData, GetCurrentUserInfoResponses, GetDeletedUsersData, GetDeletedUsersResponses, GetDocumentDiffData, GetDocumentDiffErrors, GetDocumentDiffResponses, GetDocumentVersionData, GetDocumentVersionErrors, GetDocumentVersionResponses, GetDownloadUrlData, GetDownloadUrlErrors, GetDownloadUrlResponses, GetFeatureRolloutCatalogData, GetFeatureRolloutCatalogResponses, GetInterviewData, GetInterviewErrors, GetInterviewResponses, GetInterviewSessionLogData, GetInterviewSessionLogErrors, GetInterviewSessionLogResponses, GetLatestReleaseNoteData, GetLatestReleaseNoteResponses, GetLicenseTiersData, GetLicenseTiersResponses, GetMaintenanceStatusData, GetMaintenanceStatusResponses, GetMessagesData, GetMessagesErrors, GetMessagesResponses, GetMyMembershipRightsData, GetMyMembershipRightsResponses, GetOnlineUsersData, GetOnlineUsersResponses, GetProjectInfoData, GetProjectInfoErrors, GetProjectInfoResponses, GetProjectMembersData, GetProjectMembersErrors, GetProjectMembersResponses, GetProjectsByWorkspaceData, GetProjectsByWorkspaceErrors, GetProjectsByWorkspaceResponses, GetPromptInfoData, GetPromptInfoErrors, GetPromptInfoResponses, GetPromptsByTypeData, GetPromptsByTypeErrors, GetPromptsByTypeResponses, GetPromptVersionsData, GetPromptVersionsErrors, GetPromptVersionsResponses, GetProviderModelsData, GetProviderModelsErrors, GetProviderModelsResponses, GetRaciDeliverableData, GetRaciDeliverableErrors, GetRaciDeliverableResponses, GetReleaseNoteEmailStatusData, GetReleaseNoteEmailStatusErrors, GetReleaseNoteEmailStatusResponses, GetRequirementsDeliverableData, GetRequirementsDeliverableErrors, GetRequirementsDeliverableResponses, GetRolesData, GetRolesResponses, GetSessionsData, GetSessionsErrors, GetSessionsResponses, GetSopDeliverableData, GetSopDeliverableErrors, GetSopDeliverableResponses, GetStateData, GetStateErrors, GetStateResponses, GetSummaryChatHistoryData, GetSummaryChatHistoryErrors, GetSummaryChatHistoryResponses, GetTranscriptData, GetTranscriptErrors, GetTranscriptResponses, GetUserAuditLogData, GetUserAuditLogErrors, GetUserAuditLogResponses, GetUserInfoData, GetUserInfoErrors, GetUserInfoResponses, GetUserLicenseData, GetUserLicenseErrors, GetUserLicenseResponses, GetUserLicenseUsageData, GetUserLicenseUsageErrors, GetUserLicenseUsageResponses, GetUserStoriesDeliverableData, GetUserStoriesDeliverableErrors, GetUserStoriesDeliverableResponses, GetWorkspaceInfoData, GetWorkspaceInfoErrors, GetWorkspaceInfoResponses, GetWorkspaceMembersData, GetWorkspaceMembersErrors, GetWorkspaceMembersResponses, GetWorkspacesByOwnerData, GetWorkspacesByOwnerErrors, GetWorkspacesByOwnerResponses, GetWorkspaceWithMembersData, GetWorkspaceWithMembersErrors, GetWorkspaceWithMembersResponses, HandleDocumentProcessingEventData, HandleDocumentProcessingEventErrors, HandleDocumentProcessingEventResponses, HandleKindeWebhookData, HandleKindeWebhookErrors, HandleKindeWebhookResponses, HealthCheckData, HealthCheckResponses, ImplementSummaryToolProposalData, ImplementSummaryToolProposalErrors, ImplementSummaryToolProposalResponses, IngestReleaseNoteData, IngestReleaseNoteErrors, IngestReleaseNoteResponses, ListAnalysesData, ListAnalysesErrors, ListAnalysesOverviewData, ListAnalysesOverviewErrors, ListAnalysesOverviewResponses, ListAnalysesResponses, ListAnalysisIssuesData, ListAnalysisIssuesErrors, ListAnalysisIssuesResponses, ListAssignmentsData, ListAssignmentsErrors, ListAssignmentsResponses, ListDocumentProcessingRunsData, ListDocumentProcessingRunsErrors, ListDocumentProcessingRunsResponses, ListDocumentVersionsData, ListDocumentVersionsErrors, ListDocumentVersionsResponses, ListInterviewProcessesData, ListInterviewProcessesErrors, ListInterviewProcessesResponses, ListProvidersData, ListProvidersErrors, ListProvidersResponses, ListReleaseNotesData, ListReleaseNotesResponses, LockDocumentVersionData, LockDocumentVersionErrors, LockDocumentVersionResponses, Login2FaData, Login2FaErrors, Login2FaResponses, LoginData, LoginErrors, LoginResponses, LogoutData, LogoutResponses, MarkReleaseNoteSeenData, MarkReleaseNoteSeenErrors, MarkReleaseNoteSeenResponses, MemoryDiagnosticsData, MemoryDiagnosticsResponses, PasswordForgottenData, PasswordForgottenErrors, PasswordForgottenResponses, PatchAnalysisNameData, PatchAnalysisNameErrors, PatchAnalysisNameResponses, PatchDocumentVersionData, PatchDocumentVersionErrors, PatchDocumentVersionResponses, PatchFeatureRolloutGlobalPhaseData, PatchFeatureRolloutGlobalPhaseErrors, PatchFeatureRolloutGlobalPhaseResponses, PatchMyFeatureRolloutData, PatchMyFeatureRolloutErrors, PatchMyFeatureRolloutResponses, PatchUserFeatureRolloutAdminData, PatchUserFeatureRolloutAdminErrors, PatchUserFeatureRolloutAdminResponses, PingData, PingResponses, PreviewReleaseNoteEmailData, PreviewReleaseNoteEmailErrors, PreviewReleaseNoteEmailResponses, ProviderHealthCheckData, ProviderHealthCheckResponses, RedisHealthCheckData, RedisHealthCheckResponses, RefreshTokenData, RefreshTokenResponses, RegenerateSummaryData, RegenerateSummaryErrors, RegenerateSummaryResponses, RemoveProjectMemberData, RemoveProjectMemberErrors, RemoveProjectMemberResponses, RemoveWorkspaceMemberData, RemoveWorkspaceMemberErrors, RemoveWorkspaceMemberResponses, RenameProjectData, RenameProjectErrors, RenameProjectResponses, RenderPromptData, RenderPromptErrors, RenderPromptResponses, ReopenAnalysisIssueData, ReopenAnalysisIssueErrors, ReopenAnalysisIssueResponses, RequestUploadData, RequestUploadErrors, RequestUploadResponses, ResetOwn2FaData, ResetOwn2FaResponses, ResolveAnalysisIssueData, ResolveAnalysisIssueErrors, ResolveAnalysisIssueResponses, RestartAnalysisData, RestartAnalysisErrors, RestartAnalysisResponses, RestoreDocumentVersionData, RestoreDocumentVersionErrors, RestoreDocumentVersionResponses, RestoreUserData, RestoreUserErrors, RestoreUserResponses, SearchCompaniesByNameData, SearchCompaniesByNameErrors, SearchCompaniesByNameResponses, SeedTourArtifactData, SeedTourArtifactErrors, SeedTourArtifactResponses, SendReleaseNoteEmailData, SendReleaseNoteEmailErrors, SendReleaseNoteEmailResponses, SendVerificationEmailData, SendVerificationEmailErrors, SendVerificationEmailResponses, SetCompanyLicenseLockedData, SetCompanyLicenseLockedErrors, SetCompanyLicenseLockedResponses, SetPasswordData, SetPasswordErrors, SetPasswordResponses, Setup2FaData, Setup2FaErrors, Setup2FaResponses, SetUserLicenseLockedData, SetUserLicenseLockedErrors, SetUserLicenseLockedResponses, SsoCallbackData, SsoCallbackErrors, SsoCallbackResponses, SsoCheckData, SsoCheckErrors, SsoCheckResponses, StartInterviewData, StartInterviewErrors, StartInterviewResponses, StreamMessageData, StreamMessageErrors, StreamMessageResponses, StreamOpeningData, StreamOpeningErrors, StreamOpeningResponses, TerminateOtherSessionsData, TerminateOtherSessionsResponses, TerminateSessionData, TerminateSessionErrors, TerminateSessionResponses, TransitionAnalysisIssueData, TransitionAnalysisIssueErrors, TransitionAnalysisIssueResponses, UnlockDocumentData, UnlockDocumentErrors, UnlockDocumentResponses, UpdateAnalysisIssueData, UpdateAnalysisIssueErrors, UpdateAnalysisIssueResponses, UpdateArtifactData, UpdateArtifactErrors, UpdateArtifactResponses, UpdateAssignmentData, UpdateAssignmentErrors, UpdateAssignmentResponses, UpdateCompanyBillingDetailsData, UpdateCompanyBillingDetailsErrors, UpdateCompanyBillingDetailsResponses, UpdateCompanyData, UpdateCompanyErrors, UpdateCompanyFlagsData, UpdateCompanyFlagsErrors, UpdateCompanyFlagsResponses, UpdateCompanyResponses, UpdateMaintenanceData, UpdateMaintenanceErrors, UpdateMaintenanceResponses, UpdateModelData, UpdateModelErrors, UpdateModelResponses, UpdateProjectData, UpdateProjectErrors, UpdateProjectMemberData, UpdateProjectMemberErrors, UpdateProjectMemberResponses, UpdateProjectResponses, UpdatePromptData, UpdatePromptErrors, UpdatePromptResponses, UpdateRaciDeliverableData, UpdateRaciDeliverableErrors, UpdateRaciDeliverableResponses, UpdateReleaseNoteData, UpdateReleaseNoteErrors, UpdateReleaseNoteResponses, UpdateRequirementsDeliverableData, UpdateRequirementsDeliverableErrors, UpdateRequirementsDeliverableResponses, UpdateSopDeliverableData, UpdateSopDeliverableErrors, UpdateSopDeliverableResponses, UpdateSummaryData, UpdateSummaryErrors, UpdateSummaryResponses, UpdateSummaryToolProposalStatusData, UpdateSummaryToolProposalStatusErrors, UpdateSummaryToolProposalStatusResponses, UpdateTextContentData, UpdateTextContentErrors, UpdateTextContentResponses, UpdateTranscriptData, UpdateTranscriptErrors, UpdateTranscriptResponses, UpdateUserBulkPathData, UpdateUserBulkPathErrors, UpdateUserBulkPathResponses, UpdateUserData, UpdateUserErrors, UpdateUserFlagsData, UpdateUserFlagsErrors, UpdateUserFlagsResponses, UpdateUserResponses, UpdateUserStoriesDeliverableData, UpdateUserStoriesDeliverableErrors, UpdateUserStoriesDeliverableResponses, UpdateWorkspaceMemberData, UpdateWorkspaceMemberErrors, UpdateWorkspaceMemberResponses, ValidateResetTokenData, ValidateResetTokenErrors, ValidateResetTokenResponses, Verify2FaSetupData, Verify2FaSetupErrors, Verify2FaSetupResponses, VerifyEmailData, VerifyEmailErrors, VerifyEmailResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Login
 *
 * Login endpoint
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>): RequestResult<LoginResponses, LoginErrors, ThrowOnError> => (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: '/api/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login 2Fa
 *
 * Verify 2FA code and complete login
 */
export const login2Fa = <ThrowOnError extends boolean = false>(options: Options<Login2FaData, ThrowOnError>): RequestResult<Login2FaResponses, Login2FaErrors, ThrowOnError> => (options.client ?? client).post<Login2FaResponses, Login2FaErrors, ThrowOnError>({
    url: '/api/auth/2fa/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logout
 *
 * Logout endpoint
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({ url: '/api/auth/logout', ...options });

/**
 * Refresh Token
 *
 * Refresh access token using refresh token cookie.
 */
export const refreshToken = <ThrowOnError extends boolean = false>(options?: Options<RefreshTokenData, ThrowOnError>): RequestResult<RefreshTokenResponses, unknown, ThrowOnError> => (options?.client ?? client).post<RefreshTokenResponses, unknown, ThrowOnError>({ url: '/api/auth/refresh', ...options });

/**
 * Get Current User Info
 *
 * Get current user information. Allows users with pending terms so they can complete the flow.
 */
export const getCurrentUserInfo = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserInfoData, ThrowOnError>): RequestResult<GetCurrentUserInfoResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCurrentUserInfoResponses, unknown, ThrowOnError>({ url: '/api/auth/me', ...options });

/**
 * Setup 2Fa
 *
 * Setup 2FA for the current user
 */
export const setup2Fa = <ThrowOnError extends boolean = false>(options: Options<Setup2FaData, ThrowOnError>): RequestResult<Setup2FaResponses, Setup2FaErrors, ThrowOnError> => (options.client ?? client).post<Setup2FaResponses, Setup2FaErrors, ThrowOnError>({
    url: '/api/auth/2fa/setup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify 2Fa Setup
 *
 * Verify 2FA setup with the provided code
 */
export const verify2FaSetup = <ThrowOnError extends boolean = false>(options: Options<Verify2FaSetupData, ThrowOnError>): RequestResult<Verify2FaSetupResponses, Verify2FaSetupErrors, ThrowOnError> => (options.client ?? client).post<Verify2FaSetupResponses, Verify2FaSetupErrors, ThrowOnError>({
    url: '/api/auth/2fa/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Own 2Fa
 *
 * Reset 2FA for the current user (must set up again).
 */
export const resetOwn2Fa = <ThrowOnError extends boolean = false>(options?: Options<ResetOwn2FaData, ThrowOnError>): RequestResult<ResetOwn2FaResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ResetOwn2FaResponses, unknown, ThrowOnError>({ url: '/api/auth/2fa/reset', ...options });

/**
 * Password Forgotten
 *
 * Send a reset password email to the user
 */
export const passwordForgotten = <ThrowOnError extends boolean = false>(options: Options<PasswordForgottenData, ThrowOnError>): RequestResult<PasswordForgottenResponses, PasswordForgottenErrors, ThrowOnError> => (options.client ?? client).post<PasswordForgottenResponses, PasswordForgottenErrors, ThrowOnError>({
    url: '/api/auth/password-forgotten',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Password Reset
 *
 * Confirm password reset with token
 */
export const confirmPasswordReset = <ThrowOnError extends boolean = false>(options: Options<ConfirmPasswordResetData, ThrowOnError>): RequestResult<ConfirmPasswordResetResponses, ConfirmPasswordResetErrors, ThrowOnError> => (options.client ?? client).post<ConfirmPasswordResetResponses, ConfirmPasswordResetErrors, ThrowOnError>({
    url: '/api/auth/password-reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate Reset Token
 *
 * Validate password reset token. Returns whether user should reset password or complete onboarding.
 */
export const validateResetToken = <ThrowOnError extends boolean = false>(options: Options<ValidateResetTokenData, ThrowOnError>): RequestResult<ValidateResetTokenResponses, ValidateResetTokenErrors, ThrowOnError> => (options.client ?? client).post<ValidateResetTokenResponses, ValidateResetTokenErrors, ThrowOnError>({
    url: '/api/auth/validate-reset-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sso Check
 *
 * Check if email requires SSO authentication
 */
export const ssoCheck = <ThrowOnError extends boolean = false>(options: Options<SsoCheckData, ThrowOnError>): RequestResult<SsoCheckResponses, SsoCheckErrors, ThrowOnError> => (options.client ?? client).post<SsoCheckResponses, SsoCheckErrors, ThrowOnError>({
    url: '/api/auth/sso-check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sso Callback
 *
 * Handle SSO callback from Kinde and redirect to frontend.
 */
export const ssoCallback = <ThrowOnError extends boolean = false>(options: Options<SsoCallbackData, ThrowOnError>): RequestResult<SsoCallbackResponses, SsoCallbackErrors, ThrowOnError> => (options.client ?? client).get<SsoCallbackResponses, SsoCallbackErrors, ThrowOnError>({ url: '/api/auth/sso/callback', ...options });

/**
 * Admin Reset 2Fa
 *
 * Admin reset 2FA for a user after identity verification (requires SUPER_ADMIN role)
 */
export const adminReset2Fa = <ThrowOnError extends boolean = false>(options: Options<AdminReset2FaData, ThrowOnError>): RequestResult<AdminReset2FaResponses, AdminReset2FaErrors, ThrowOnError> => (options.client ?? client).post<AdminReset2FaResponses, AdminReset2FaErrors, ThrowOnError>({
    url: '/api/auth/2fa/admin-reset/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Verification Email
 *
 * Send verification email to user
 */
export const sendVerificationEmail = <ThrowOnError extends boolean = false>(options: Options<SendVerificationEmailData, ThrowOnError>): RequestResult<SendVerificationEmailResponses, SendVerificationEmailErrors, ThrowOnError> => (options.client ?? client).post<SendVerificationEmailResponses, SendVerificationEmailErrors, ThrowOnError>({
    url: '/api/auth/send-verification-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Email
 *
 * Verify user email with token. If onboarding not complete (and not in-app), returns tokens for redirect.
 */
export const verifyEmail = <ThrowOnError extends boolean = false>(options: Options<VerifyEmailData, ThrowOnError>): RequestResult<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError> => (options.client ?? client).post<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError>({
    url: '/api/auth/verify-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Terms
 *
 * Accept terms and conditions. Allows users with pending terms to complete this step.
 */
export const acceptTerms = <ThrowOnError extends boolean = false>(options: Options<AcceptTermsData, ThrowOnError>): RequestResult<AcceptTermsResponses, AcceptTermsErrors, ThrowOnError> => (options.client ?? client).post<AcceptTermsResponses, AcceptTermsErrors, ThrowOnError>({
    url: '/api/auth/accept-terms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Password
 *
 * Set password for user during onboarding (non-SSO users only)
 */
export const setPassword = <ThrowOnError extends boolean = false>(options: Options<SetPasswordData, ThrowOnError>): RequestResult<SetPasswordResponses, SetPasswordErrors, ThrowOnError> => (options.client ?? client).post<SetPasswordResponses, SetPasswordErrors, ThrowOnError>({
    url: '/api/auth/set-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Sessions
 *
 * Get current user's sessions
 */
export const getSessions = <ThrowOnError extends boolean = false>(options?: Options<GetSessionsData, ThrowOnError>): RequestResult<GetSessionsResponses, GetSessionsErrors, ThrowOnError> => (options?.client ?? client).get<GetSessionsResponses, GetSessionsErrors, ThrowOnError>({ url: '/api/sessions', ...options });

/**
 * Terminate Other Sessions
 *
 * Terminate all other sessions (except current)
 */
export const terminateOtherSessions = <ThrowOnError extends boolean = false>(options?: Options<TerminateOtherSessionsData, ThrowOnError>): RequestResult<TerminateOtherSessionsResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<TerminateOtherSessionsResponses, unknown, ThrowOnError>({ url: '/api/sessions/other', ...options });

/**
 * Terminate Session
 *
 * Terminate a specific session
 */
export const terminateSession = <ThrowOnError extends boolean = false>(options: Options<TerminateSessionData, ThrowOnError>): RequestResult<TerminateSessionResponses, TerminateSessionErrors, ThrowOnError> => (options.client ?? client).delete<TerminateSessionResponses, TerminateSessionErrors, ThrowOnError>({ url: '/api/sessions/{session_id}', ...options });

/**
 * Get Online Users
 *
 * Get list of online users (admin only)
 */
export const getOnlineUsers = <ThrowOnError extends boolean = false>(options?: Options<GetOnlineUsersData, ThrowOnError>): RequestResult<GetOnlineUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetOnlineUsersResponses, unknown, ThrowOnError>({ url: '/api/sessions/online', ...options });

/**
 * Bulk Reset Terms
 *
 * Reset terms acceptance for all non-deleted users (super admin).
 */
export const bulkResetTerms = <ThrowOnError extends boolean = false>(options: Options<BulkResetTermsData, ThrowOnError>): RequestResult<BulkResetTermsResponses, BulkResetTermsErrors, ThrowOnError> => (options.client ?? client).post<BulkResetTermsResponses, BulkResetTermsErrors, ThrowOnError>({
    url: '/api/bulk-actions/users/reset-terms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Patch My Feature Rollout
 *
 * Update current user's opt-in for an exposed beta feature.
 */
export const patchMyFeatureRollout = <ThrowOnError extends boolean = false>(options: Options<PatchMyFeatureRolloutData, ThrowOnError>): RequestResult<PatchMyFeatureRolloutResponses, PatchMyFeatureRolloutErrors, ThrowOnError> => (options.client ?? client).patch<PatchMyFeatureRolloutResponses, PatchMyFeatureRolloutErrors, ThrowOnError>({
    url: '/api/users/me/feature-rollouts/{feature_key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Feature Rollout Catalog
 *
 * List registered feature rollout definitions (super admin only).
 */
export const getFeatureRolloutCatalog = <ThrowOnError extends boolean = false>(options?: Options<GetFeatureRolloutCatalogData, ThrowOnError>): RequestResult<GetFeatureRolloutCatalogResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetFeatureRolloutCatalogResponses, unknown, ThrowOnError>({ url: '/api/users/feature-rollouts/catalog', ...options });

/**
 * Patch Feature Rollout Global Phase
 *
 * Set global rollout phase for a feature (super admin only).
 */
export const patchFeatureRolloutGlobalPhase = <ThrowOnError extends boolean = false>(options: Options<PatchFeatureRolloutGlobalPhaseData, ThrowOnError>): RequestResult<PatchFeatureRolloutGlobalPhaseResponses, PatchFeatureRolloutGlobalPhaseErrors, ThrowOnError> => (options.client ?? client).patch<PatchFeatureRolloutGlobalPhaseResponses, PatchFeatureRolloutGlobalPhaseErrors, ThrowOnError>({
    url: '/api/users/feature-rollouts/{feature_key}/phase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Patch User Feature Rollout Admin
 *
 * Set admin override for a user's feature rollout (super admin only).
 */
export const patchUserFeatureRolloutAdmin = <ThrowOnError extends boolean = false>(options: Options<PatchUserFeatureRolloutAdminData, ThrowOnError>): RequestResult<PatchUserFeatureRolloutAdminResponses, PatchUserFeatureRolloutAdminErrors, ThrowOnError> => (options.client ?? client).patch<PatchUserFeatureRolloutAdminResponses, PatchUserFeatureRolloutAdminErrors, ThrowOnError>({
    url: '/api/users/{user_id}/feature-rollouts/{feature_key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get All Users
 *
 * Get all users (super admin only)
 */
export const getAllUsers = <ThrowOnError extends boolean = false>(options?: Options<GetAllUsersData, ThrowOnError>): RequestResult<GetAllUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAllUsersResponses, unknown, ThrowOnError>({ url: '/api/users/', ...options });

/**
 * Create User
 *
 * Create a new user (requires SUPER_ADMIN role)
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>): RequestResult<CreateUserResponses, CreateUserErrors, ThrowOnError> => (options.client ?? client).post<CreateUserResponses, CreateUserErrors, ThrowOnError>({
    url: '/api/users/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Deleted Users
 *
 * Get all deleted users (super admin only)
 */
export const getDeletedUsers = <ThrowOnError extends boolean = false>(options?: Options<GetDeletedUsersData, ThrowOnError>): RequestResult<GetDeletedUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetDeletedUsersResponses, unknown, ThrowOnError>({ url: '/api/users/deleted', ...options });

/**
 * Get User Audit Log
 *
 * Audit log for admin/automation actions on this user (super admin only).
 */
export const getUserAuditLog = <ThrowOnError extends boolean = false>(options: Options<GetUserAuditLogData, ThrowOnError>): RequestResult<GetUserAuditLogResponses, GetUserAuditLogErrors, ThrowOnError> => (options.client ?? client).get<GetUserAuditLogResponses, GetUserAuditLogErrors, ThrowOnError>({ url: '/api/users/{user_id}/audit-log', ...options });

/**
 * Delete User
 *
 * Soft delete a user
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>): RequestResult<DeleteUserResponses, DeleteUserErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
    url: '/api/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Info
 *
 * Get user information by ID.
 *
 * Full profile: self or super admin. Same company: limited public fields only (no email/phone).
 * Otherwise 403.
 */
export const getUserInfo = <ThrowOnError extends boolean = false>(options: Options<GetUserInfoData, ThrowOnError>): RequestResult<GetUserInfoResponses, GetUserInfoErrors, ThrowOnError> => (options.client ?? client).get<GetUserInfoResponses, GetUserInfoErrors, ThrowOnError>({ url: '/api/users/{user_id}', ...options });

/**
 * Update User
 *
 * Update user profile information (super admin can update any user, company admin can update users in same company, users can update themselves).
 */
export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>): RequestResult<UpdateUserResponses, UpdateUserErrors, ThrowOnError> => (options.client ?? client).put<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
    url: '/api/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Super Admin
 *
 * Create a new super admin user
 */
export const createSuperAdmin = <ThrowOnError extends boolean = false>(options: Options<CreateSuperAdminData, ThrowOnError>): RequestResult<CreateSuperAdminResponses, CreateSuperAdminErrors, ThrowOnError> => (options.client ?? client).post<CreateSuperAdminResponses, CreateSuperAdminErrors, ThrowOnError>({
    url: '/api/users/super-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Bulk Users
 *
 * Create multiple users at once
 */
export const createBulkUsers = <ThrowOnError extends boolean = false>(options: Options<CreateBulkUsersData, ThrowOnError>): RequestResult<CreateBulkUsersResponses, CreateBulkUsersErrors, ThrowOnError> => (options.client ?? client).post<CreateBulkUsersResponses, CreateBulkUsersErrors, ThrowOnError>({
    url: '/api/users/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update User Bulk Path
 *
 * Alias for updating user via /bulk/{user_id} to match test expectations
 */
export const updateUserBulkPath = <ThrowOnError extends boolean = false>(options: Options<UpdateUserBulkPathData, ThrowOnError>): RequestResult<UpdateUserBulkPathResponses, UpdateUserBulkPathErrors, ThrowOnError> => (options.client ?? client).put<UpdateUserBulkPathResponses, UpdateUserBulkPathErrors, ThrowOnError>({
    url: '/api/users/bulk/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update User Flags
 *
 * Update user flags (active, verified, terms).
 */
export const updateUserFlags = <ThrowOnError extends boolean = false>(options: Options<UpdateUserFlagsData, ThrowOnError>): RequestResult<UpdateUserFlagsResponses, UpdateUserFlagsErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUserFlagsResponses, UpdateUserFlagsErrors, ThrowOnError>({
    url: '/api/users/{user_id}/flags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restore User
 *
 * Restore a deleted user
 */
export const restoreUser = <ThrowOnError extends boolean = false>(options: Options<RestoreUserData, ThrowOnError>): RequestResult<RestoreUserResponses, RestoreUserErrors, ThrowOnError> => (options.client ?? client).post<RestoreUserResponses, RestoreUserErrors, ThrowOnError>({ url: '/api/users/{user_id}/restore', ...options });

/**
 * Complete Onboarding
 *
 * Complete onboarding for the current user
 */
export const completeOnboarding = <ThrowOnError extends boolean = false>(options?: Options<CompleteOnboardingData, ThrowOnError>): RequestResult<CompleteOnboardingResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CompleteOnboardingResponses, unknown, ThrowOnError>({ url: '/api/users/complete-onboarding', ...options });

/**
 * Get License Tiers
 *
 * Get all license tiers
 */
export const getLicenseTiers = <ThrowOnError extends boolean = false>(options?: Options<GetLicenseTiersData, ThrowOnError>): RequestResult<GetLicenseTiersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetLicenseTiersResponses, unknown, ThrowOnError>({ url: '/api/constants/license-tiers', ...options });

/**
 * Get Roles
 *
 * Get all roles
 */
export const getRoles = <ThrowOnError extends boolean = false>(options?: Options<GetRolesData, ThrowOnError>): RequestResult<GetRolesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRolesResponses, unknown, ThrowOnError>({ url: '/api/constants/roles', ...options });

/**
 * Get Projects By Workspace
 *
 * Get all projects for a specific workspace, ordered by most recently updated first.
 */
export const getProjectsByWorkspace = <ThrowOnError extends boolean = false>(options: Options<GetProjectsByWorkspaceData, ThrowOnError>): RequestResult<GetProjectsByWorkspaceResponses, GetProjectsByWorkspaceErrors, ThrowOnError> => (options.client ?? client).get<GetProjectsByWorkspaceResponses, GetProjectsByWorkspaceErrors, ThrowOnError>({ url: '/api/projects/workspace/{workspace_id}', ...options });

/**
 * Delete Project
 *
 * Soft delete a project
 */
export const deleteProject = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectData, ThrowOnError>): RequestResult<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError>({ url: '/api/projects/{project_id}', ...options });

/**
 * Get Project Info
 *
 * Get project information by ID (requires project VIEW access)
 */
export const getProjectInfo = <ThrowOnError extends boolean = false>(options: Options<GetProjectInfoData, ThrowOnError>): RequestResult<GetProjectInfoResponses, GetProjectInfoErrors, ThrowOnError> => (options.client ?? client).get<GetProjectInfoResponses, GetProjectInfoErrors, ThrowOnError>({ url: '/api/projects/{project_id}', ...options });

/**
 * Update Project
 *
 * Update project information (requires project EDIT access)
 */
export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>): RequestResult<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError> => (options.client ?? client).put<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
    url: '/api/projects/{project_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Project
 *
 * Create a new project (requires workspace project creation permission for the workspace the project is being created in)
 */
export const createProject = <ThrowOnError extends boolean = false>(options: Options<CreateProjectData, ThrowOnError>): RequestResult<CreateProjectResponses, CreateProjectErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectResponses, CreateProjectErrors, ThrowOnError>({
    url: '/api/projects/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rename Project
 *
 * Rename a project (requires project EDIT access)
 */
export const renameProject = <ThrowOnError extends boolean = false>(options: Options<RenameProjectData, ThrowOnError>): RequestResult<RenameProjectResponses, RenameProjectErrors, ThrowOnError> => (options.client ?? client).patch<RenameProjectResponses, RenameProjectErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/rename',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Project Members
 *
 * Get all members of a project (requires project VIEW access)
 */
export const getProjectMembers = <ThrowOnError extends boolean = false>(options: Options<GetProjectMembersData, ThrowOnError>): RequestResult<GetProjectMembersResponses, GetProjectMembersErrors, ThrowOnError> => (options.client ?? client).get<GetProjectMembersResponses, GetProjectMembersErrors, ThrowOnError>({ url: '/api/projects/{project_id}/members', ...options });

/**
 * Add Project Member
 *
 * Add a member to a project (requires project ADMIN access)
 */
export const addProjectMember = <ThrowOnError extends boolean = false>(options: Options<AddProjectMemberData, ThrowOnError>): RequestResult<AddProjectMemberResponses, AddProjectMemberErrors, ThrowOnError> => (options.client ?? client).post<AddProjectMemberResponses, AddProjectMemberErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Project Member
 *
 * Remove a member from a project (requires project ADMIN access)
 */
export const removeProjectMember = <ThrowOnError extends boolean = false>(options: Options<RemoveProjectMemberData, ThrowOnError>): RequestResult<RemoveProjectMemberResponses, RemoveProjectMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveProjectMemberResponses, RemoveProjectMemberErrors, ThrowOnError>({ url: '/api/projects/{project_id}/members/{user_id}', ...options });

/**
 * Update Project Member
 *
 * Update a project member's role (requires project ADMIN access)
 */
export const updateProjectMember = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectMemberData, ThrowOnError>): RequestResult<UpdateProjectMemberResponses, UpdateProjectMemberErrors, ThrowOnError> => (options.client ?? client).put<UpdateProjectMemberResponses, UpdateProjectMemberErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/members/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List analyses
 *
 * List all analyses for a project with pagination
 */
export const listAnalyses = <ThrowOnError extends boolean = false>(options: Options<ListAnalysesData, ThrowOnError>): RequestResult<ListAnalysesResponses, ListAnalysesErrors, ThrowOnError> => (options.client ?? client).get<ListAnalysesResponses, ListAnalysesErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses', ...options });

/**
 * Create analysis
 *
 * Create a new analysis with source artifacts
 */
export const createAnalysis = <ThrowOnError extends boolean = false>(options: Options<CreateAnalysisData, ThrowOnError>): RequestResult<CreateAnalysisResponses, CreateAnalysisErrors, ThrowOnError> => (options.client ?? client).post<CreateAnalysisResponses, CreateAnalysisErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List analyses overview
 *
 * List analyses for a project with minimal metadata (no snapshot data)
 */
export const listAnalysesOverview = <ThrowOnError extends boolean = false>(options: Options<ListAnalysesOverviewData, ThrowOnError>): RequestResult<ListAnalysesOverviewResponses, ListAnalysesOverviewErrors, ThrowOnError> => (options.client ?? client).get<ListAnalysesOverviewResponses, ListAnalysesOverviewErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/overview', ...options });

/**
 * Delete analysis
 *
 * Delete an analysis and all associated data
 */
export const deleteAnalysis = <ThrowOnError extends boolean = false>(options: Options<DeleteAnalysisData, ThrowOnError>): RequestResult<DeleteAnalysisResponses, DeleteAnalysisErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAnalysisResponses, DeleteAnalysisErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}', ...options });

/**
 * Get analysis
 *
 * Get analysis by ID with full details
 */
export const getAnalysis = <ThrowOnError extends boolean = false>(options: Options<GetAnalysisData, ThrowOnError>): RequestResult<GetAnalysisResponses, GetAnalysisErrors, ThrowOnError> => (options.client ?? client).get<GetAnalysisResponses, GetAnalysisErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}', ...options });

/**
 * Update analysis (rename)
 *
 * Update analysis display name. Requires project edit permission.
 */
export const patchAnalysisName = <ThrowOnError extends boolean = false>(options: Options<PatchAnalysisNameData, ThrowOnError>): RequestResult<PatchAnalysisNameResponses, PatchAnalysisNameErrors, ThrowOnError> => (options.client ?? client).patch<PatchAnalysisNameResponses, PatchAnalysisNameErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate summary
 *
 * Generate structured summary from source artifacts using AI (initial generation only)
 */
export const generateSummary = <ThrowOnError extends boolean = false>(options: Options<GenerateSummaryData, ThrowOnError>): RequestResult<GenerateSummaryResponses, GenerateSummaryErrors, ThrowOnError> => (options.client ?? client).post<GenerateSummaryResponses, GenerateSummaryErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/summary/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Regenerate summary
 *
 * Regenerate selected sections of an existing summary while preserving non-selected sections
 */
export const regenerateSummary = <ThrowOnError extends boolean = false>(options: Options<RegenerateSummaryData, ThrowOnError>): RequestResult<RegenerateSummaryResponses, RegenerateSummaryErrors, ThrowOnError> => (options.client ?? client).post<RegenerateSummaryResponses, RegenerateSummaryErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/summary/regenerate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Convert legacy summary to structured
 *
 * Convert a legacy textual summary (sections-based) to structured_v1 JSON using AI. No-op error if the summary is already structured.
 */
export const convertLegacySummary = <ThrowOnError extends boolean = false>(options: Options<ConvertLegacySummaryData, ThrowOnError>): RequestResult<ConvertLegacySummaryResponses, ConvertLegacySummaryErrors, ThrowOnError> => (options.client ?? client).post<ConvertLegacySummaryResponses, ConvertLegacySummaryErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/summary/convert',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update summary
 *
 * Update the summary data (user edits)
 */
export const updateSummary = <ThrowOnError extends boolean = false>(options: Options<UpdateSummaryData, ThrowOnError>): RequestResult<UpdateSummaryResponses, UpdateSummaryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSummaryResponses, UpdateSummaryErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/summary',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update model
 *
 * Update the model data (user edits)
 */
export const updateModel = <ThrowOnError extends boolean = false>(options: Options<UpdateModelData, ThrowOnError>): RequestResult<UpdateModelResponses, UpdateModelErrors, ThrowOnError> => (options.client ?? client).patch<UpdateModelResponses, UpdateModelErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/model',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate model
 *
 * Generate target model (BPMN, etc.) from the summary using AI
 */
export const generateModel = <ThrowOnError extends boolean = false>(options: Options<GenerateModelData, ThrowOnError>): RequestResult<GenerateModelResponses, GenerateModelErrors, ThrowOnError> => (options.client ?? client).post<GenerateModelResponses, GenerateModelErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/model/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export model to Visio
 *
 * Export the analysis model to Microsoft Visio (.vsdx) format
 */
export const exportModelToVisio = <ThrowOnError extends boolean = false>(options: Options<ExportModelToVisioData, ThrowOnError>): RequestResult<ExportModelToVisioResponses, ExportModelToVisioErrors, ThrowOnError> => (options.client ?? client).get<ExportModelToVisioResponses, ExportModelToVisioErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/model/export/visio', ...options });

/**
 * Export model to PowerPoint
 *
 * Export the analysis model to Microsoft PowerPoint (.pptx) format
 */
export const exportModelToPptx = <ThrowOnError extends boolean = false>(options: Options<ExportModelToPptxData, ThrowOnError>): RequestResult<ExportModelToPptxResponses, ExportModelToPptxErrors, ThrowOnError> => (options.client ?? client).get<ExportModelToPptxResponses, ExportModelToPptxErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/model/export/pptx', ...options });

/**
 * Restart failed analysis
 *
 * Retry generation from where it got stuck: if summary exists, generates the model from it; otherwise retries summary generation.
 */
export const restartAnalysis = <ThrowOnError extends boolean = false>(options: Options<RestartAnalysisData, ThrowOnError>): RequestResult<RestartAnalysisResponses, RestartAnalysisErrors, ThrowOnError> => (options.client ?? client).post<RestartAnalysisResponses, RestartAnalysisErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/restart', ...options });

/**
 * List document versions
 */
export const listDocumentVersions = <ThrowOnError extends boolean = false>(options: Options<ListDocumentVersionsData, ThrowOnError>): RequestResult<ListDocumentVersionsResponses, ListDocumentVersionsErrors, ThrowOnError> => (options.client ?? client).get<ListDocumentVersionsResponses, ListDocumentVersionsErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/versions', ...options });

/**
 * Create named document version
 */
export const createDocumentVersion = <ThrowOnError extends boolean = false>(options: Options<CreateDocumentVersionData, ThrowOnError>): RequestResult<CreateDocumentVersionResponses, CreateDocumentVersionErrors, ThrowOnError> => (options.client ?? client).post<CreateDocumentVersionResponses, CreateDocumentVersionErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Diff two document versions
 */
export const getDocumentDiff = <ThrowOnError extends boolean = false>(options: Options<GetDocumentDiffData, ThrowOnError>): RequestResult<GetDocumentDiffResponses, GetDocumentDiffErrors, ThrowOnError> => (options.client ?? client).get<GetDocumentDiffResponses, GetDocumentDiffErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/diff', ...options });

/**
 * Get document version with snapshot
 */
export const getDocumentVersion = <ThrowOnError extends boolean = false>(options: Options<GetDocumentVersionData, ThrowOnError>): RequestResult<GetDocumentVersionResponses, GetDocumentVersionErrors, ThrowOnError> => (options.client ?? client).get<GetDocumentVersionResponses, GetDocumentVersionErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/versions/{version_id}', ...options });

/**
 * Rename or update document version status
 */
export const patchDocumentVersion = <ThrowOnError extends boolean = false>(options: Options<PatchDocumentVersionData, ThrowOnError>): RequestResult<PatchDocumentVersionResponses, PatchDocumentVersionErrors, ThrowOnError> => (options.client ?? client).patch<PatchDocumentVersionResponses, PatchDocumentVersionErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/versions/{version_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restore document version
 */
export const restoreDocumentVersion = <ThrowOnError extends boolean = false>(options: Options<RestoreDocumentVersionData, ThrowOnError>): RequestResult<RestoreDocumentVersionResponses, RestoreDocumentVersionErrors, ThrowOnError> => (options.client ?? client).post<RestoreDocumentVersionResponses, RestoreDocumentVersionErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/versions/{version_id}/restore', ...options });

/**
 * Lock document version as immutable record
 */
export const lockDocumentVersion = <ThrowOnError extends boolean = false>(options: Options<LockDocumentVersionData, ThrowOnError>): RequestResult<LockDocumentVersionResponses, LockDocumentVersionErrors, ThrowOnError> => (options.client ?? client).post<LockDocumentVersionResponses, LockDocumentVersionErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/versions/{version_id}/lock', ...options });

/**
 * Unlock approved document for editing
 */
export const unlockDocument = <ThrowOnError extends boolean = false>(options: Options<UnlockDocumentData, ThrowOnError>): RequestResult<UnlockDocumentResponses, UnlockDocumentErrors, ThrowOnError> => (options.client ?? client).post<UnlockDocumentResponses, UnlockDocumentErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/document/unlock', ...options });

/**
 * Flush autosave checkpoint
 */
export const flushDocumentCheckpoint = <ThrowOnError extends boolean = false>(options: Options<FlushDocumentCheckpointData, ThrowOnError>): RequestResult<FlushDocumentCheckpointResponses, FlushDocumentCheckpointErrors, ThrowOnError> => (options.client ?? client).post<FlushDocumentCheckpointResponses, FlushDocumentCheckpointErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/versions/checkpoint', ...options });

/**
 * List issues for an analysis
 */
export const listAnalysisIssues = <ThrowOnError extends boolean = false>(options: Options<ListAnalysisIssuesData, ThrowOnError>): RequestResult<ListAnalysisIssuesResponses, ListAnalysisIssuesErrors, ThrowOnError> => (options.client ?? client).get<ListAnalysisIssuesResponses, ListAnalysisIssuesErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/issues', ...options });

/**
 * Update an analysis issue
 */
export const updateAnalysisIssue = <ThrowOnError extends boolean = false>(options: Options<UpdateAnalysisIssueData, ThrowOnError>): RequestResult<UpdateAnalysisIssueResponses, UpdateAnalysisIssueErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAnalysisIssueResponses, UpdateAnalysisIssueErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/issues/{issue_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Address an analysis issue
 */
export const resolveAnalysisIssue = <ThrowOnError extends boolean = false>(options: Options<ResolveAnalysisIssueData, ThrowOnError>): RequestResult<ResolveAnalysisIssueResponses, ResolveAnalysisIssueErrors, ThrowOnError> => (options.client ?? client).post<ResolveAnalysisIssueResponses, ResolveAnalysisIssueErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/issues/{issue_id}/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reopen an addressed analysis issue
 */
export const reopenAnalysisIssue = <ThrowOnError extends boolean = false>(options: Options<ReopenAnalysisIssueData, ThrowOnError>): RequestResult<ReopenAnalysisIssueResponses, ReopenAnalysisIssueErrors, ThrowOnError> => (options.client ?? client).post<ReopenAnalysisIssueResponses, ReopenAnalysisIssueErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/issues/{issue_id}/reopen', ...options });

/**
 * Transition an analysis issue on the review board
 */
export const transitionAnalysisIssue = <ThrowOnError extends boolean = false>(options: Options<TransitionAnalysisIssueData, ThrowOnError>): RequestResult<TransitionAnalysisIssueResponses, TransitionAnalysisIssueErrors, ThrowOnError> => (options.client ?? client).post<TransitionAnalysisIssueResponses, TransitionAnalysisIssueErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/issues/{issue_id}/transition',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get SOP deliverable
 */
export const getSopDeliverable = <ThrowOnError extends boolean = false>(options: Options<GetSopDeliverableData, ThrowOnError>): RequestResult<GetSopDeliverableResponses, GetSopDeliverableErrors, ThrowOnError> => (options.client ?? client).get<GetSopDeliverableResponses, GetSopDeliverableErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/deliverables/sop', ...options });

/**
 * Update SOP deliverable
 */
export const updateSopDeliverable = <ThrowOnError extends boolean = false>(options: Options<UpdateSopDeliverableData, ThrowOnError>): RequestResult<UpdateSopDeliverableResponses, UpdateSopDeliverableErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSopDeliverableResponses, UpdateSopDeliverableErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/deliverables/sop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate SOP deliverable
 */
export const generateSopDeliverable = <ThrowOnError extends boolean = false>(options: Options<GenerateSopDeliverableData, ThrowOnError>): RequestResult<GenerateSopDeliverableResponses, GenerateSopDeliverableErrors, ThrowOnError> => (options.client ?? client).post<GenerateSopDeliverableResponses, GenerateSopDeliverableErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/deliverables/sop/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get RACI deliverable
 */
export const getRaciDeliverable = <ThrowOnError extends boolean = false>(options: Options<GetRaciDeliverableData, ThrowOnError>): RequestResult<GetRaciDeliverableResponses, GetRaciDeliverableErrors, ThrowOnError> => (options.client ?? client).get<GetRaciDeliverableResponses, GetRaciDeliverableErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/deliverables/raci', ...options });

/**
 * Update RACI deliverable
 */
export const updateRaciDeliverable = <ThrowOnError extends boolean = false>(options: Options<UpdateRaciDeliverableData, ThrowOnError>): RequestResult<UpdateRaciDeliverableResponses, UpdateRaciDeliverableErrors, ThrowOnError> => (options.client ?? client).patch<UpdateRaciDeliverableResponses, UpdateRaciDeliverableErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/deliverables/raci',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate RACI deliverable
 */
export const generateRaciDeliverable = <ThrowOnError extends boolean = false>(options: Options<GenerateRaciDeliverableData, ThrowOnError>): RequestResult<GenerateRaciDeliverableResponses, GenerateRaciDeliverableErrors, ThrowOnError> => (options.client ?? client).post<GenerateRaciDeliverableResponses, GenerateRaciDeliverableErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/deliverables/raci/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user stories deliverable
 */
export const getUserStoriesDeliverable = <ThrowOnError extends boolean = false>(options: Options<GetUserStoriesDeliverableData, ThrowOnError>): RequestResult<GetUserStoriesDeliverableResponses, GetUserStoriesDeliverableErrors, ThrowOnError> => (options.client ?? client).get<GetUserStoriesDeliverableResponses, GetUserStoriesDeliverableErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/deliverables/user-stories', ...options });

/**
 * Update user stories deliverable
 */
export const updateUserStoriesDeliverable = <ThrowOnError extends boolean = false>(options: Options<UpdateUserStoriesDeliverableData, ThrowOnError>): RequestResult<UpdateUserStoriesDeliverableResponses, UpdateUserStoriesDeliverableErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUserStoriesDeliverableResponses, UpdateUserStoriesDeliverableErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/deliverables/user-stories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate user stories deliverable
 */
export const generateUserStoriesDeliverable = <ThrowOnError extends boolean = false>(options: Options<GenerateUserStoriesDeliverableData, ThrowOnError>): RequestResult<GenerateUserStoriesDeliverableResponses, GenerateUserStoriesDeliverableErrors, ThrowOnError> => (options.client ?? client).post<GenerateUserStoriesDeliverableResponses, GenerateUserStoriesDeliverableErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/deliverables/user-stories/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get requirements deliverable
 */
export const getRequirementsDeliverable = <ThrowOnError extends boolean = false>(options: Options<GetRequirementsDeliverableData, ThrowOnError>): RequestResult<GetRequirementsDeliverableResponses, GetRequirementsDeliverableErrors, ThrowOnError> => (options.client ?? client).get<GetRequirementsDeliverableResponses, GetRequirementsDeliverableErrors, ThrowOnError>({ url: '/api/projects/{project_id}/analyses/{analysis_id}/deliverables/requirements', ...options });

/**
 * Update requirements deliverable
 */
export const updateRequirementsDeliverable = <ThrowOnError extends boolean = false>(options: Options<UpdateRequirementsDeliverableData, ThrowOnError>): RequestResult<UpdateRequirementsDeliverableResponses, UpdateRequirementsDeliverableErrors, ThrowOnError> => (options.client ?? client).patch<UpdateRequirementsDeliverableResponses, UpdateRequirementsDeliverableErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/deliverables/requirements',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate requirements deliverable
 */
export const generateRequirementsDeliverable = <ThrowOnError extends boolean = false>(options: Options<GenerateRequirementsDeliverableData, ThrowOnError>): RequestResult<GenerateRequirementsDeliverableResponses, GenerateRequirementsDeliverableErrors, ThrowOnError> => (options.client ?? client).post<GenerateRequirementsDeliverableResponses, GenerateRequirementsDeliverableErrors, ThrowOnError>({
    url: '/api/projects/{project_id}/analyses/{analysis_id}/deliverables/requirements/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Prompts By Type
 *
 * Get all prompts of a specific type, optionally filtered by language and company
 */
export const getPromptsByType = <ThrowOnError extends boolean = false>(options: Options<GetPromptsByTypeData, ThrowOnError>): RequestResult<GetPromptsByTypeResponses, GetPromptsByTypeErrors, ThrowOnError> => (options.client ?? client).get<GetPromptsByTypeResponses, GetPromptsByTypeErrors, ThrowOnError>({ url: '/api/prompts/type/{prompt_type}', ...options });

/**
 * Get Prompt Info
 *
 * Get prompt information by ID
 */
export const getPromptInfo = <ThrowOnError extends boolean = false>(options: Options<GetPromptInfoData, ThrowOnError>): RequestResult<GetPromptInfoResponses, GetPromptInfoErrors, ThrowOnError> => (options.client ?? client).get<GetPromptInfoResponses, GetPromptInfoErrors, ThrowOnError>({ url: '/api/prompts/{prompt_id}', ...options });

/**
 * Update Prompt
 *
 * Update an existing prompt in place (only for inactive prompts)
 */
export const updatePrompt = <ThrowOnError extends boolean = false>(options: Options<UpdatePromptData, ThrowOnError>): RequestResult<UpdatePromptResponses, UpdatePromptErrors, ThrowOnError> => (options.client ?? client).patch<UpdatePromptResponses, UpdatePromptErrors, ThrowOnError>({
    url: '/api/prompts/{prompt_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render Prompt
 *
 * Render prompt template with context variables
 */
export const renderPrompt = <ThrowOnError extends boolean = false>(options: Options<RenderPromptData, ThrowOnError>): RequestResult<RenderPromptResponses, RenderPromptErrors, ThrowOnError> => (options.client ?? client).post<RenderPromptResponses, RenderPromptErrors, ThrowOnError>({
    url: '/api/prompts/{prompt_id}/render',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Prompt Versions
 *
 * Get all versions of a prompt
 */
export const getPromptVersions = <ThrowOnError extends boolean = false>(options: Options<GetPromptVersionsData, ThrowOnError>): RequestResult<GetPromptVersionsResponses, GetPromptVersionsErrors, ThrowOnError> => (options.client ?? client).get<GetPromptVersionsResponses, GetPromptVersionsErrors, ThrowOnError>({ url: '/api/prompts/{prompt_id}/versions', ...options });

/**
 * Create Prompt Version
 *
 * Create new version of existing prompt
 */
export const createPromptVersion = <ThrowOnError extends boolean = false>(options: Options<CreatePromptVersionData, ThrowOnError>): RequestResult<CreatePromptVersionResponses, CreatePromptVersionErrors, ThrowOnError> => (options.client ?? client).post<CreatePromptVersionResponses, CreatePromptVersionErrors, ThrowOnError>({
    url: '/api/prompts/{prompt_id}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activate Prompt Version
 *
 * Activate a specific prompt version and deactivate all others in the same family
 */
export const activatePromptVersion = <ThrowOnError extends boolean = false>(options: Options<ActivatePromptVersionData, ThrowOnError>): RequestResult<ActivatePromptVersionResponses, ActivatePromptVersionErrors, ThrowOnError> => (options.client ?? client).post<ActivatePromptVersionResponses, ActivatePromptVersionErrors, ThrowOnError>({ url: '/api/prompts/{prompt_id}/activate', ...options });

/**
 * Deactivate Prompt Version
 *
 * Set a prompt version to inactive. Company prompts allowed; system defaults only if not the last active per type and language.
 */
export const deactivatePromptVersion = <ThrowOnError extends boolean = false>(options: Options<DeactivatePromptVersionData, ThrowOnError>): RequestResult<DeactivatePromptVersionResponses, DeactivatePromptVersionErrors, ThrowOnError> => (options.client ?? client).post<DeactivatePromptVersionResponses, DeactivatePromptVersionErrors, ThrowOnError>({ url: '/api/prompts/{prompt_id}/deactivate', ...options });

/**
 * Ab Test Prompts
 *
 * A/B test two prompts by calling AI with both and comparing outputs
 */
export const abTestPrompts = <ThrowOnError extends boolean = false>(options: Options<AbTestPromptsData, ThrowOnError>): RequestResult<AbTestPromptsResponses, AbTestPromptsErrors, ThrowOnError> => (options.client ?? client).post<AbTestPromptsResponses, AbTestPromptsErrors, ThrowOnError>({
    url: '/api/prompts/ab-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clone Prompt For Company
 *
 * Clone a prompt for a specific company. Returns the created prompt so the client can navigate to it.
 */
export const clonePromptForCompany = <ThrowOnError extends boolean = false>(options: Options<ClonePromptForCompanyData, ThrowOnError>): RequestResult<ClonePromptForCompanyResponses, ClonePromptForCompanyErrors, ThrowOnError> => (options.client ?? client).post<ClonePromptForCompanyResponses, ClonePromptForCompanyErrors, ThrowOnError>({
    url: '/api/prompts/{prompt_id}/clone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Workspaces By Owner
 *
 * Get all workspaces owned by a specific user (with access control filtering)
 */
export const getWorkspacesByOwner = <ThrowOnError extends boolean = false>(options: Options<GetWorkspacesByOwnerData, ThrowOnError>): RequestResult<GetWorkspacesByOwnerResponses, GetWorkspacesByOwnerErrors, ThrowOnError> => (options.client ?? client).get<GetWorkspacesByOwnerResponses, GetWorkspacesByOwnerErrors, ThrowOnError>({ url: '/api/workspaces/owner/{owner_id}', ...options });

/**
 * Create Workspace
 *
 * Create a new workspace (requires workspace creation permission for the company the workspace is being created in)
 */
export const createWorkspace = <ThrowOnError extends boolean = false>(options: Options<CreateWorkspaceData, ThrowOnError>): RequestResult<CreateWorkspaceResponses, CreateWorkspaceErrors, ThrowOnError> => (options.client ?? client).post<CreateWorkspaceResponses, CreateWorkspaceErrors, ThrowOnError>({
    url: '/api/workspaces/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Workspace Info
 *
 * Get workspace information by ID (requires workspace VIEW access)
 */
export const getWorkspaceInfo = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceInfoData, ThrowOnError>): RequestResult<GetWorkspaceInfoResponses, GetWorkspaceInfoErrors, ThrowOnError> => (options.client ?? client).get<GetWorkspaceInfoResponses, GetWorkspaceInfoErrors, ThrowOnError>({ url: '/api/workspaces/{workspace_id}', ...options });

/**
 * Get Workspace With Members
 *
 * Get workspace with its members (requires workspace ADMIN access)
 */
export const getWorkspaceWithMembers = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceWithMembersData, ThrowOnError>): RequestResult<GetWorkspaceWithMembersResponses, GetWorkspaceWithMembersErrors, ThrowOnError> => (options.client ?? client).get<GetWorkspaceWithMembersResponses, GetWorkspaceWithMembersErrors, ThrowOnError>({ url: '/api/workspaces/{workspace_id}/with-members', ...options });

/**
 * Get Workspace Members
 *
 * Get all members of a workspace (any workspace member can view)
 */
export const getWorkspaceMembers = <ThrowOnError extends boolean = false>(options: Options<GetWorkspaceMembersData, ThrowOnError>): RequestResult<GetWorkspaceMembersResponses, GetWorkspaceMembersErrors, ThrowOnError> => (options.client ?? client).get<GetWorkspaceMembersResponses, GetWorkspaceMembersErrors, ThrowOnError>({ url: '/api/workspaces/{workspace_id}/members', ...options });

/**
 * Add Workspace Member
 *
 * Add a member to a workspace (requires workspace ADD_MEMBERS permission)
 */
export const addWorkspaceMember = <ThrowOnError extends boolean = false>(options: Options<AddWorkspaceMemberData, ThrowOnError>): RequestResult<AddWorkspaceMemberResponses, AddWorkspaceMemberErrors, ThrowOnError> => (options.client ?? client).post<AddWorkspaceMemberResponses, AddWorkspaceMemberErrors, ThrowOnError>({
    url: '/api/workspaces/{workspace_id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Workspace Member
 *
 * Remove a member from a workspace
 */
export const removeWorkspaceMember = <ThrowOnError extends boolean = false>(options: Options<RemoveWorkspaceMemberData, ThrowOnError>): RequestResult<RemoveWorkspaceMemberResponses, RemoveWorkspaceMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveWorkspaceMemberResponses, RemoveWorkspaceMemberErrors, ThrowOnError>({ url: '/api/workspaces/{workspace_id}/members/{user_id}', ...options });

/**
 * Update Workspace Member
 *
 * Update a workspace member's role
 */
export const updateWorkspaceMember = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkspaceMemberData, ThrowOnError>): RequestResult<UpdateWorkspaceMemberResponses, UpdateWorkspaceMemberErrors, ThrowOnError> => (options.client ?? client).put<UpdateWorkspaceMemberResponses, UpdateWorkspaceMemberErrors, ThrowOnError>({
    url: '/api/workspaces/{workspace_id}/members/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get All Companies
 *
 * Get all companies (filtered by user access)
 */
export const getAllCompanies = <ThrowOnError extends boolean = false>(options?: Options<GetAllCompaniesData, ThrowOnError>): RequestResult<GetAllCompaniesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAllCompaniesResponses, unknown, ThrowOnError>({ url: '/api/companies/', ...options });

/**
 * Create Company
 *
 * Create a new company (requires SUPER_ADMIN role)
 */
export const createCompany = <ThrowOnError extends boolean = false>(options: Options<CreateCompanyData, ThrowOnError>): RequestResult<CreateCompanyResponses, CreateCompanyErrors, ThrowOnError> => (options.client ?? client).post<CreateCompanyResponses, CreateCompanyErrors, ThrowOnError>({
    url: '/api/companies/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Companies By Name
 *
 * Search companies by name
 */
export const searchCompaniesByName = <ThrowOnError extends boolean = false>(options: Options<SearchCompaniesByNameData, ThrowOnError>): RequestResult<SearchCompaniesByNameResponses, SearchCompaniesByNameErrors, ThrowOnError> => (options.client ?? client).get<SearchCompaniesByNameResponses, SearchCompaniesByNameErrors, ThrowOnError>({ url: '/api/companies/search', ...options });

/**
 * Delete Company
 *
 * Delete a company (super admin only)
 */
export const deleteCompany = <ThrowOnError extends boolean = false>(options: Options<DeleteCompanyData, ThrowOnError>): RequestResult<DeleteCompanyResponses, DeleteCompanyErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCompanyResponses, DeleteCompanyErrors, ThrowOnError>({ url: '/api/companies/{company_id}', ...options });

/**
 * Get Company Info
 *
 * Get company information by ID
 */
export const getCompanyInfo = <ThrowOnError extends boolean = false>(options: Options<GetCompanyInfoData, ThrowOnError>): RequestResult<GetCompanyInfoResponses, GetCompanyInfoErrors, ThrowOnError> => (options.client ?? client).get<GetCompanyInfoResponses, GetCompanyInfoErrors, ThrowOnError>({ url: '/api/companies/{company_id}', ...options });

/**
 * Update Company
 *
 * Update an existing company (requires SUPER_ADMIN role)
 */
export const updateCompany = <ThrowOnError extends boolean = false>(options: Options<UpdateCompanyData, ThrowOnError>): RequestResult<UpdateCompanyResponses, UpdateCompanyErrors, ThrowOnError> => (options.client ?? client).put<UpdateCompanyResponses, UpdateCompanyErrors, ThrowOnError>({
    url: '/api/companies/{company_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Sso Checklist
 *
 * SSO onboarding checklist (Kinde connections, test SSO URL when configured).
 */
export const getCompanySsoChecklist = <ThrowOnError extends boolean = false>(options: Options<GetCompanySsoChecklistData, ThrowOnError>): RequestResult<GetCompanySsoChecklistResponses, GetCompanySsoChecklistErrors, ThrowOnError> => (options.client ?? client).get<GetCompanySsoChecklistResponses, GetCompanySsoChecklistErrors, ThrowOnError>({ url: '/api/companies/{company_id}/sso-checklist', ...options });

/**
 * Get Company Users Bulk
 *
 * Get users for multiple companies in one request.
 */
export const getCompanyUsersBulk = <ThrowOnError extends boolean = false>(options: Options<GetCompanyUsersBulkData, ThrowOnError>): RequestResult<GetCompanyUsersBulkResponses, GetCompanyUsersBulkErrors, ThrowOnError> => (options.client ?? client).get<GetCompanyUsersBulkResponses, GetCompanyUsersBulkErrors, ThrowOnError>({ url: '/api/companies/bulk/users', ...options });

/**
 * Get Company Licenses Bulk
 *
 * Get licenses for multiple companies in one request.
 */
export const getCompanyLicensesBulk = <ThrowOnError extends boolean = false>(options: Options<GetCompanyLicensesBulkData, ThrowOnError>): RequestResult<GetCompanyLicensesBulkResponses, GetCompanyLicensesBulkErrors, ThrowOnError> => (options.client ?? client).get<GetCompanyLicensesBulkResponses, GetCompanyLicensesBulkErrors, ThrowOnError>({ url: '/api/companies/bulk/licenses', ...options });

/**
 * Get Company Billing Details
 *
 * Get billing details for a company (super admin only).
 */
export const getCompanyBillingDetails = <ThrowOnError extends boolean = false>(options: Options<GetCompanyBillingDetailsData, ThrowOnError>): RequestResult<GetCompanyBillingDetailsResponses, GetCompanyBillingDetailsErrors, ThrowOnError> => (options.client ?? client).get<GetCompanyBillingDetailsResponses, GetCompanyBillingDetailsErrors, ThrowOnError>({ url: '/api/companies/{company_id}/billing-details', ...options });

/**
 * Update Company Billing Details
 *
 * Update billing details for a company (super admin only, partial update).
 */
export const updateCompanyBillingDetails = <ThrowOnError extends boolean = false>(options: Options<UpdateCompanyBillingDetailsData, ThrowOnError>): RequestResult<UpdateCompanyBillingDetailsResponses, UpdateCompanyBillingDetailsErrors, ThrowOnError> => (options.client ?? client).put<UpdateCompanyBillingDetailsResponses, UpdateCompanyBillingDetailsErrors, ThrowOnError>({
    url: '/api/companies/{company_id}/billing-details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Users
 *
 * Get users associated with a company
 */
export const getCompanyUsers = <ThrowOnError extends boolean = false>(options: Options<GetCompanyUsersData, ThrowOnError>): RequestResult<GetCompanyUsersResponses, GetCompanyUsersErrors, ThrowOnError> => (options.client ?? client).get<GetCompanyUsersResponses, GetCompanyUsersErrors, ThrowOnError>({ url: '/api/companies/{company_id}/users', ...options });

/**
 * Update Company Flags
 *
 * Update SSO partner flags on a company (super admin only).
 */
export const updateCompanyFlags = <ThrowOnError extends boolean = false>(options: Options<UpdateCompanyFlagsData, ThrowOnError>): RequestResult<UpdateCompanyFlagsResponses, UpdateCompanyFlagsErrors, ThrowOnError> => (options.client ?? client).patch<UpdateCompanyFlagsResponses, UpdateCompanyFlagsErrors, ThrowOnError>({
    url: '/api/companies/{company_id}/flags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Membership Rights
 *
 * Get all membership rights for the current authenticated user.
 *
 * Returns a flat list of all workspace, project, and artifact memberships
 * with their associated roles and permissions. This endpoint is cached
 * and automatically invalidated when memberships change.
 */
export const getMyMembershipRights = <ThrowOnError extends boolean = false>(options?: Options<GetMyMembershipRightsData, ThrowOnError>): RequestResult<GetMyMembershipRightsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyMembershipRightsResponses, unknown, ThrowOnError>({ url: '/api/role-hierarchy/me/rights', ...options });

/**
 * Assign User License
 *
 * Assign user license to user - PREMIUM tier only
 */
export const assignUserLicense = <ThrowOnError extends boolean = false>(options: Options<AssignUserLicenseData, ThrowOnError>): RequestResult<AssignUserLicenseResponses, AssignUserLicenseErrors, ThrowOnError> => (options.client ?? client).post<AssignUserLicenseResponses, AssignUserLicenseErrors, ThrowOnError>({
    url: '/api/user-licenses/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User License
 *
 * Get user's effective license tier
 */
export const getUserLicense = <ThrowOnError extends boolean = false>(options: Options<GetUserLicenseData, ThrowOnError>): RequestResult<GetUserLicenseResponses, GetUserLicenseErrors, ThrowOnError> => (options.client ?? client).get<GetUserLicenseResponses, GetUserLicenseErrors, ThrowOnError>({ url: '/api/user-licenses/{user_id}', ...options });

/**
 * Get User License Usage
 *
 * Get current usage statistics for user's license tier
 */
export const getUserLicenseUsage = <ThrowOnError extends boolean = false>(options: Options<GetUserLicenseUsageData, ThrowOnError>): RequestResult<GetUserLicenseUsageResponses, GetUserLicenseUsageErrors, ThrowOnError> => (options.client ?? client).get<GetUserLicenseUsageResponses, GetUserLicenseUsageErrors, ThrowOnError>({ url: '/api/user-licenses/{user_id}/usage', ...options });

/**
 * Extend User License
 *
 * Extend subscription end date for a user — super admin only
 */
export const extendUserLicense = <ThrowOnError extends boolean = false>(options: Options<ExtendUserLicenseData, ThrowOnError>): RequestResult<ExtendUserLicenseResponses, ExtendUserLicenseErrors, ThrowOnError> => (options.client ?? client).patch<ExtendUserLicenseResponses, ExtendUserLicenseErrors, ThrowOnError>({
    url: '/api/user-licenses/{user_id}/extend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set User License Locked
 *
 * Lock or unlock a user's license — super admin only
 */
export const setUserLicenseLocked = <ThrowOnError extends boolean = false>(options: Options<SetUserLicenseLockedData, ThrowOnError>): RequestResult<SetUserLicenseLockedResponses, SetUserLicenseLockedErrors, ThrowOnError> => (options.client ?? client).patch<SetUserLicenseLockedResponses, SetUserLicenseLockedErrors, ThrowOnError>({
    url: '/api/user-licenses/{user_id}/lock',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign Company License
 *
 * Assign company license to company
 */
export const assignCompanyLicense = <ThrowOnError extends boolean = false>(options: Options<AssignCompanyLicenseData, ThrowOnError>): RequestResult<AssignCompanyLicenseResponses, AssignCompanyLicenseErrors, ThrowOnError> => (options.client ?? client).post<AssignCompanyLicenseResponses, AssignCompanyLicenseErrors, ThrowOnError>({
    url: '/api/company-licenses/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company License
 *
 * Get companies license information
 */
export const getCompanyLicense = <ThrowOnError extends boolean = false>(options: Options<GetCompanyLicenseData, ThrowOnError>): RequestResult<GetCompanyLicenseResponses, GetCompanyLicenseErrors, ThrowOnError> => (options.client ?? client).get<GetCompanyLicenseResponses, GetCompanyLicenseErrors, ThrowOnError>({ url: '/api/company-licenses/{company_id}', ...options });

/**
 * Get Company License Usage
 *
 * Get current usage statistics for companies license
 */
export const getCompanyLicenseUsage = <ThrowOnError extends boolean = false>(options: Options<GetCompanyLicenseUsageData, ThrowOnError>): RequestResult<GetCompanyLicenseUsageResponses, GetCompanyLicenseUsageErrors, ThrowOnError> => (options.client ?? client).get<GetCompanyLicenseUsageResponses, GetCompanyLicenseUsageErrors, ThrowOnError>({ url: '/api/company-licenses/{company_id}/usage', ...options });

/**
 * Adjust Company Premium Seats
 *
 * Increase or decrease company premium seat count by one — super admin only
 */
export const adjustCompanyPremiumSeats = <ThrowOnError extends boolean = false>(options: Options<AdjustCompanyPremiumSeatsData, ThrowOnError>): RequestResult<AdjustCompanyPremiumSeatsResponses, AdjustCompanyPremiumSeatsErrors, ThrowOnError> => (options.client ?? client).post<AdjustCompanyPremiumSeatsResponses, AdjustCompanyPremiumSeatsErrors, ThrowOnError>({
    url: '/api/company-licenses/{company_id}/premium-seats/adjust',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Company License Locked
 *
 * Lock or unlock a company's license (locks all users) — super admin only
 */
export const setCompanyLicenseLocked = <ThrowOnError extends boolean = false>(options: Options<SetCompanyLicenseLockedData, ThrowOnError>): RequestResult<SetCompanyLicenseLockedResponses, SetCompanyLicenseLockedErrors, ThrowOnError> => (options.client ?? client).patch<SetCompanyLicenseLockedResponses, SetCompanyLicenseLockedErrors, ThrowOnError>({
    url: '/api/company-licenses/{company_id}/lock',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request presigned upload URL
 *
 * Request a presigned URL for uploading an artifact file directly to S3 with KMS encryption
 */
export const requestUpload = <ThrowOnError extends boolean = false>(options: Options<RequestUploadData, ThrowOnError>): RequestResult<RequestUploadResponses, RequestUploadErrors, ThrowOnError> => (options.client ?? client).post<RequestUploadResponses, RequestUploadErrors, ThrowOnError>({
    url: '/api/artifacts/project/{project_id}/request-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm upload completion
 *
 * Confirm that file upload to S3 has completed successfully
 */
export const confirmUpload = <ThrowOnError extends boolean = false>(options: Options<ConfirmUploadData, ThrowOnError>): RequestResult<ConfirmUploadResponses, ConfirmUploadErrors, ThrowOnError> => (options.client ?? client).post<ConfirmUploadResponses, ConfirmUploadErrors, ThrowOnError>({
    url: '/api/artifacts/project/{project_id}/artifacts/{artifact_id}/confirm-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Seed completed tour artifact
 *
 * Create a completed artifact with deterministic processed content for the product tour (no presigned client upload or document pipeline)
 */
export const seedTourArtifact = <ThrowOnError extends boolean = false>(options: Options<SeedTourArtifactData, ThrowOnError>): RequestResult<SeedTourArtifactResponses, SeedTourArtifactErrors, ThrowOnError> => (options.client ?? client).post<SeedTourArtifactResponses, SeedTourArtifactErrors, ThrowOnError>({
    url: '/api/artifacts/project/{project_id}/tour-seed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List artifacts
 *
 * Get paginated list of artifacts for a project with optional filtering
 */
export const getArtifactsByProject = <ThrowOnError extends boolean = false>(options: Options<GetArtifactsByProjectData, ThrowOnError>): RequestResult<GetArtifactsByProjectResponses, GetArtifactsByProjectErrors, ThrowOnError> => (options.client ?? client).get<GetArtifactsByProjectResponses, GetArtifactsByProjectErrors, ThrowOnError>({ url: '/api/artifacts/project/{project_id}/artifacts', ...options });

/**
 * Delete artifact
 *
 * Delete an artifact and its associated file from storage
 */
export const deleteArtifact = <ThrowOnError extends boolean = false>(options: Options<DeleteArtifactData, ThrowOnError>): RequestResult<DeleteArtifactResponses, DeleteArtifactErrors, ThrowOnError> => (options.client ?? client).delete<DeleteArtifactResponses, DeleteArtifactErrors, ThrowOnError>({ url: '/api/artifacts/project/{project_id}/artifacts/{artifact_id}', ...options });

/**
 * Get artifact details
 *
 * Get detailed information about a specific artifact
 */
export const getArtifactById = <ThrowOnError extends boolean = false>(options: Options<GetArtifactByIdData, ThrowOnError>): RequestResult<GetArtifactByIdResponses, GetArtifactByIdErrors, ThrowOnError> => (options.client ?? client).get<GetArtifactByIdResponses, GetArtifactByIdErrors, ThrowOnError>({ url: '/api/artifacts/project/{project_id}/artifacts/{artifact_id}', ...options });

/**
 * Update artifact
 *
 * Update artifact metadata including name and instructions
 */
export const updateArtifact = <ThrowOnError extends boolean = false>(options: Options<UpdateArtifactData, ThrowOnError>): RequestResult<UpdateArtifactResponses, UpdateArtifactErrors, ThrowOnError> => (options.client ?? client).put<UpdateArtifactResponses, UpdateArtifactErrors, ThrowOnError>({
    url: '/api/artifacts/project/{project_id}/artifacts/{artifact_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get transcript
 *
 * Get transcript content for an artifact (e.g. audio)
 */
export const getTranscript = <ThrowOnError extends boolean = false>(options: Options<GetTranscriptData, ThrowOnError>): RequestResult<GetTranscriptResponses, GetTranscriptErrors, ThrowOnError> => (options.client ?? client).get<GetTranscriptResponses, GetTranscriptErrors, ThrowOnError>({ url: '/api/artifacts/project/{project_id}/artifacts/{artifact_id}/transcript', ...options });

/**
 * Update transcript
 *
 * Update transcript content for an artifact
 */
export const updateTranscript = <ThrowOnError extends boolean = false>(options: Options<UpdateTranscriptData, ThrowOnError>): RequestResult<UpdateTranscriptResponses, UpdateTranscriptErrors, ThrowOnError> => (options.client ?? client).put<UpdateTranscriptResponses, UpdateTranscriptErrors, ThrowOnError>({
    url: '/api/artifacts/project/{project_id}/artifacts/{artifact_id}/transcript',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update text/markdown artifact content
 *
 * Update content of a text or markdown artifact in-place
 */
export const updateTextContent = <ThrowOnError extends boolean = false>(options: Options<UpdateTextContentData, ThrowOnError>): RequestResult<UpdateTextContentResponses, UpdateTextContentErrors, ThrowOnError> => (options.client ?? client).put<UpdateTextContentResponses, UpdateTextContentErrors, ThrowOnError>({
    url: '/api/artifacts/project/{project_id}/artifacts/{artifact_id}/content',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get download URL
 *
 * Get a presigned URL for downloading an artifact file
 */
export const getDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<GetDownloadUrlData, ThrowOnError>): RequestResult<GetDownloadUrlResponses, GetDownloadUrlErrors, ThrowOnError> => (options.client ?? client).get<GetDownloadUrlResponses, GetDownloadUrlErrors, ThrowOnError>({ url: '/api/artifacts/project/{project_id}/artifacts/{artifact_id}/download-url', ...options });

/**
 * Bulk remove artifacts
 *
 * Remove multiple artifacts at once, optionally cancelling in-flight processing first
 */
export const bulkDeleteArtifacts = <ThrowOnError extends boolean = false>(options: Options<BulkDeleteArtifactsData, ThrowOnError>): RequestResult<BulkDeleteArtifactsResponses, BulkDeleteArtifactsErrors, ThrowOnError> => (options.client ?? client).delete<BulkDeleteArtifactsResponses, BulkDeleteArtifactsErrors, ThrowOnError>({
    url: '/api/artifacts/project/{project_id}/artifacts/bulk-remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ping
 *
 * Lightweight health check for container orchestration (Docker/Kubernetes).
 *
 * Returns immediately without checking external dependencies.
 * Use this for Docker HEALTHCHECK or Kubernetes liveness probes.
 *
 * For comprehensive service health, use /api/health instead.
 */
export const ping = <ThrowOnError extends boolean = false>(options?: Options<PingData, ThrowOnError>): RequestResult<PingResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PingResponses, unknown, ThrowOnError>({ url: '/api/ping', ...options });

/**
 * Health Check
 *
 * Comprehensive health check endpoint for all external services.
 *
 * Checks:
 * - Database (PostgreSQL)
 * - Redis
 * - Kinde (SSO)
 * - KMS (Key Management)
 * - S3 (Storage)
 * - Email (AWS SES)
 * - Step Functions (AWS)
 *
 * Returns health status for each service.
 * Use /api/ping for container health checks (faster, no dependencies).
 */
export const healthCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckData, ThrowOnError>): RequestResult<HealthCheckResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthCheckResponses, unknown, ThrowOnError>({ url: '/api/health', ...options });

/**
 * Database Health Check
 *
 * Database-only health check for external monitoring.
 *
 * Returns:
 * - 200 if PostgreSQL is healthy
 * - 503 if PostgreSQL is unhealthy
 */
export const databaseHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<DatabaseHealthCheckData, ThrowOnError>): RequestResult<DatabaseHealthCheckResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DatabaseHealthCheckResponses, unknown, ThrowOnError>({ url: '/api/health/database', ...options });

/**
 * Redis Health Check
 *
 * Redis-only health check for external monitoring.
 *
 * Returns:
 * - 200 if Redis is healthy
 * - 503 if Redis is unhealthy
 */
export const redisHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<RedisHealthCheckData, ThrowOnError>): RequestResult<RedisHealthCheckResponses, unknown, ThrowOnError> => (options?.client ?? client).get<RedisHealthCheckResponses, unknown, ThrowOnError>({ url: '/api/health/redis', ...options });

/**
 * Celery Health Check
 *
 * Celery document pipeline metrics: queue depths (Redis) and worker inspect.
 *
 * Requires super admin. If the Step Functions provider is not Celery, returns
 * ``status: not_applicable``.
 */
export const celeryHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<CeleryHealthCheckData, ThrowOnError>): RequestResult<CeleryHealthCheckResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CeleryHealthCheckResponses, unknown, ThrowOnError>({ url: '/api/health/celery', ...options });

/**
 * List Document Processing Runs
 *
 * Paginated document-processing Celery run ledger (``document_processing_runs``).
 *
 * Requires super admin. Rows are written by doc-processing workers.
 */
export const listDocumentProcessingRuns = <ThrowOnError extends boolean = false>(options?: Options<ListDocumentProcessingRunsData, ThrowOnError>): RequestResult<ListDocumentProcessingRunsResponses, ListDocumentProcessingRunsErrors, ThrowOnError> => (options?.client ?? client).get<ListDocumentProcessingRunsResponses, ListDocumentProcessingRunsErrors, ThrowOnError>({ url: '/api/health/document-processing/runs', ...options });

/**
 * Document Processing Runs Summary
 *
 * Aggregate pipeline run counts for the admin ledger dashboard.
 */
export const documentProcessingRunsSummary = <ThrowOnError extends boolean = false>(options?: Options<DocumentProcessingRunsSummaryData, ThrowOnError>): RequestResult<DocumentProcessingRunsSummaryResponses, DocumentProcessingRunsSummaryErrors, ThrowOnError> => (options?.client ?? client).get<DocumentProcessingRunsSummaryResponses, DocumentProcessingRunsSummaryErrors, ThrowOnError>({ url: '/api/health/document-processing/runs/summary', ...options });

/**
 * Provider Health Check
 *
 * Lightweight provider health endpoint backed by Redis cache.
 *
 * Returns merged provider health computed by the background checker:
 * - Internal signal: provider error rates from AIExecution over rolling window
 * - External signal: provider status page polling
 */
export const providerHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<ProviderHealthCheckData, ThrowOnError>): RequestResult<ProviderHealthCheckResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProviderHealthCheckResponses, unknown, ThrowOnError>({ url: '/api/health/providers', ...options });

/**
 * Memory Diagnostics
 *
 * Memory diagnostics for container monitoring.
 *
 * Returns process RSS/VMS, Python GC stats, SQLAlchemy pool stats,
 * and container memory limit when available (Linux/Docker).
 */
export const memoryDiagnostics = <ThrowOnError extends boolean = false>(options?: Options<MemoryDiagnosticsData, ThrowOnError>): RequestResult<MemoryDiagnosticsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MemoryDiagnosticsResponses, unknown, ThrowOnError>({ url: '/api/health/memory', ...options });

/**
 * Get Maintenance Status
 *
 * Public maintenance status for banner and overlay (no auth required).
 */
export const getMaintenanceStatus = <ThrowOnError extends boolean = false>(options?: Options<GetMaintenanceStatusData, ThrowOnError>): RequestResult<GetMaintenanceStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMaintenanceStatusResponses, unknown, ThrowOnError>({ url: '/api/maintenance/status', ...options });

/**
 * Update Maintenance
 *
 * Update maintenance settings (super admin only).
 */
export const updateMaintenance = <ThrowOnError extends boolean = false>(options: Options<UpdateMaintenanceData, ThrowOnError>): RequestResult<UpdateMaintenanceResponses, UpdateMaintenanceErrors, ThrowOnError> => (options.client ?? client).put<UpdateMaintenanceResponses, UpdateMaintenanceErrors, ThrowOnError>({
    url: '/api/maintenance',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Latest Release Note
 */
export const getLatestReleaseNote = <ThrowOnError extends boolean = false>(options?: Options<GetLatestReleaseNoteData, ThrowOnError>): RequestResult<GetLatestReleaseNoteResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetLatestReleaseNoteResponses, unknown, ThrowOnError>({ url: '/api/release-notes/latest', ...options });

/**
 * List Release Notes
 */
export const listReleaseNotes = <ThrowOnError extends boolean = false>(options?: Options<ListReleaseNotesData, ThrowOnError>): RequestResult<ListReleaseNotesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListReleaseNotesResponses, unknown, ThrowOnError>({ url: '/api/release-notes', ...options });

/**
 * Preview Release Note Email
 */
export const previewReleaseNoteEmail = <ThrowOnError extends boolean = false>(options: Options<PreviewReleaseNoteEmailData, ThrowOnError>): RequestResult<PreviewReleaseNoteEmailResponses, PreviewReleaseNoteEmailErrors, ThrowOnError> => (options.client ?? client).post<PreviewReleaseNoteEmailResponses, PreviewReleaseNoteEmailErrors, ThrowOnError>({
    url: '/api/release-notes/preview-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ingest Release Note
 */
export const ingestReleaseNote = <ThrowOnError extends boolean = false>(options: Options<IngestReleaseNoteData, ThrowOnError>): RequestResult<IngestReleaseNoteResponses, IngestReleaseNoteErrors, ThrowOnError> => (options.client ?? client).post<IngestReleaseNoteResponses, IngestReleaseNoteErrors, ThrowOnError>({
    url: '/api/release-notes/ingest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Release Note Seen
 */
export const markReleaseNoteSeen = <ThrowOnError extends boolean = false>(options: Options<MarkReleaseNoteSeenData, ThrowOnError>): RequestResult<MarkReleaseNoteSeenResponses, MarkReleaseNoteSeenErrors, ThrowOnError> => (options.client ?? client).post<MarkReleaseNoteSeenResponses, MarkReleaseNoteSeenErrors, ThrowOnError>({ url: '/api/release-notes/{note_id}/seen', ...options });

/**
 * Update Release Note
 */
export const updateReleaseNote = <ThrowOnError extends boolean = false>(options: Options<UpdateReleaseNoteData, ThrowOnError>): RequestResult<UpdateReleaseNoteResponses, UpdateReleaseNoteErrors, ThrowOnError> => (options.client ?? client).put<UpdateReleaseNoteResponses, UpdateReleaseNoteErrors, ThrowOnError>({
    url: '/api/release-notes/{note_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Release Note Email
 */
export const sendReleaseNoteEmail = <ThrowOnError extends boolean = false>(options: Options<SendReleaseNoteEmailData, ThrowOnError>): RequestResult<SendReleaseNoteEmailResponses, SendReleaseNoteEmailErrors, ThrowOnError> => (options.client ?? client).post<SendReleaseNoteEmailResponses, SendReleaseNoteEmailErrors, ThrowOnError>({ url: '/api/release-notes/{note_id}/send-email', ...options });

/**
 * Get Release Note Email Status
 */
export const getReleaseNoteEmailStatus = <ThrowOnError extends boolean = false>(options: Options<GetReleaseNoteEmailStatusData, ThrowOnError>): RequestResult<GetReleaseNoteEmailStatusResponses, GetReleaseNoteEmailStatusErrors, ThrowOnError> => (options.client ?? client).get<GetReleaseNoteEmailStatusResponses, GetReleaseNoteEmailStatusErrors, ThrowOnError>({ url: '/api/release-notes/{note_id}/send-email/status', ...options });

/**
 * List Assignments
 */
export const listAssignments = <ThrowOnError extends boolean = false>(options: Options<ListAssignmentsData, ThrowOnError>): RequestResult<ListAssignmentsResponses, ListAssignmentsErrors, ThrowOnError> => (options.client ?? client).get<ListAssignmentsResponses, ListAssignmentsErrors, ThrowOnError>({ url: '/api/interviews/assignments', ...options });

/**
 * Create Assignments
 */
export const createAssignments = <ThrowOnError extends boolean = false>(options: Options<CreateAssignmentsData, ThrowOnError>): RequestResult<CreateAssignmentsResponses, CreateAssignmentsErrors, ThrowOnError> => (options.client ?? client).post<CreateAssignmentsResponses, CreateAssignmentsErrors, ThrowOnError>({
    url: '/api/interviews/assignments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Assignment
 */
export const deleteAssignment = <ThrowOnError extends boolean = false>(options: Options<DeleteAssignmentData, ThrowOnError>): RequestResult<DeleteAssignmentResponses, DeleteAssignmentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAssignmentResponses, DeleteAssignmentErrors, ThrowOnError>({ url: '/api/interviews/assignments/{assignment_id}', ...options });

/**
 * Get Assignment
 */
export const getAssignment = <ThrowOnError extends boolean = false>(options: Options<GetAssignmentData, ThrowOnError>): RequestResult<GetAssignmentResponses, GetAssignmentErrors, ThrowOnError> => (options.client ?? client).get<GetAssignmentResponses, GetAssignmentErrors, ThrowOnError>({ url: '/api/interviews/assignments/{assignment_id}', ...options });

/**
 * Update Assignment
 */
export const updateAssignment = <ThrowOnError extends boolean = false>(options: Options<UpdateAssignmentData, ThrowOnError>): RequestResult<UpdateAssignmentResponses, UpdateAssignmentErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAssignmentResponses, UpdateAssignmentErrors, ThrowOnError>({
    url: '/api/interviews/assignments/{assignment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Interview Processes
 */
export const listInterviewProcesses = <ThrowOnError extends boolean = false>(options: Options<ListInterviewProcessesData, ThrowOnError>): RequestResult<ListInterviewProcessesResponses, ListInterviewProcessesErrors, ThrowOnError> => (options.client ?? client).get<ListInterviewProcessesResponses, ListInterviewProcessesErrors, ThrowOnError>({ url: '/api/interviews/processes', ...options });

/**
 * Create Interview Process
 */
export const createInterviewProcess = <ThrowOnError extends boolean = false>(options: Options<CreateInterviewProcessData, ThrowOnError>): RequestResult<CreateInterviewProcessResponses, CreateInterviewProcessErrors, ThrowOnError> => (options.client ?? client).post<CreateInterviewProcessResponses, CreateInterviewProcessErrors, ThrowOnError>({
    url: '/api/interviews/processes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Interview
 */
export const startInterview = <ThrowOnError extends boolean = false>(options: Options<StartInterviewData, ThrowOnError>): RequestResult<StartInterviewResponses, StartInterviewErrors, ThrowOnError> => (options.client ?? client).post<StartInterviewResponses, StartInterviewErrors, ThrowOnError>({ url: '/api/interviews/assignments/{assignment_id}/start', ...options });

/**
 * Stream Message
 */
export const streamMessage = <ThrowOnError extends boolean = false>(options: Options<StreamMessageData, ThrowOnError>): RequestResult<StreamMessageResponses, StreamMessageErrors, ThrowOnError> => (options.client ?? client).post<StreamMessageResponses, StreamMessageErrors, ThrowOnError>({
    url: '/api/interviews/{interview_id}/message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stream Opening
 */
export const streamOpening = <ThrowOnError extends boolean = false>(options: Options<StreamOpeningData, ThrowOnError>): RequestResult<StreamOpeningResponses, StreamOpeningErrors, ThrowOnError> => (options.client ?? client).post<StreamOpeningResponses, StreamOpeningErrors, ThrowOnError>({ url: '/api/interviews/{interview_id}/opening', ...options });

/**
 * Get Interview
 */
export const getInterview = <ThrowOnError extends boolean = false>(options: Options<GetInterviewData, ThrowOnError>): RequestResult<GetInterviewResponses, GetInterviewErrors, ThrowOnError> => (options.client ?? client).get<GetInterviewResponses, GetInterviewErrors, ThrowOnError>({ url: '/api/interviews/{interview_id}', ...options });

/**
 * Get Messages
 */
export const getMessages = <ThrowOnError extends boolean = false>(options: Options<GetMessagesData, ThrowOnError>): RequestResult<GetMessagesResponses, GetMessagesErrors, ThrowOnError> => (options.client ?? client).get<GetMessagesResponses, GetMessagesErrors, ThrowOnError>({ url: '/api/interviews/{interview_id}/messages', ...options });

/**
 * Get State
 */
export const getState = <ThrowOnError extends boolean = false>(options: Options<GetStateData, ThrowOnError>): RequestResult<GetStateResponses, GetStateErrors, ThrowOnError> => (options.client ?? client).get<GetStateResponses, GetStateErrors, ThrowOnError>({ url: '/api/interviews/{interview_id}/state', ...options });

/**
 * Get Interview Session Log
 *
 * Append-only session-log read (SCRUM-653).
 */
export const getInterviewSessionLog = <ThrowOnError extends boolean = false>(options: Options<GetInterviewSessionLogData, ThrowOnError>): RequestResult<GetInterviewSessionLogResponses, GetInterviewSessionLogErrors, ThrowOnError> => (options.client ?? client).get<GetInterviewSessionLogResponses, GetInterviewSessionLogErrors, ThrowOnError>({ url: '/api/interviews/{interview_id}/session-log', ...options });

/**
 * Archive Interview
 */
export const archiveInterview = <ThrowOnError extends boolean = false>(options: Options<ArchiveInterviewData, ThrowOnError>): RequestResult<ArchiveInterviewResponses, ArchiveInterviewErrors, ThrowOnError> => (options.client ?? client).post<ArchiveInterviewResponses, ArchiveInterviewErrors, ThrowOnError>({ url: '/api/interviews/{interview_id}/archive', ...options });

/**
 * Kinde webhooks
 *
 * Receives Kinde webhook events as a JWT string (Content-Type: application/jwt). Verifies the token via Kinde JWKS. On user.deleted or user.updated with is_suspended=true, deactivates the matching user and ends sessions.
 */
export const handleKindeWebhook = <ThrowOnError extends boolean = false>(options?: Options<HandleKindeWebhookData, ThrowOnError>): RequestResult<HandleKindeWebhookResponses, HandleKindeWebhookErrors, ThrowOnError> => (options?.client ?? client).post<HandleKindeWebhookResponses, HandleKindeWebhookErrors, ThrowOnError>({ url: '/api/webhooks/kinde', ...options });

/**
 * Document Processing Webhook
 *
 * Webhook endpoint for document processing events with API key authentication
 */
export const handleDocumentProcessingEvent = <ThrowOnError extends boolean = false>(options?: Options<HandleDocumentProcessingEventData, ThrowOnError>): RequestResult<HandleDocumentProcessingEventResponses, HandleDocumentProcessingEventErrors, ThrowOnError> => (options?.client ?? client).post<HandleDocumentProcessingEventResponses, HandleDocumentProcessingEventErrors, ThrowOnError>({ url: '/api/webhooks/document-processing', ...options });

/**
 * List Providers
 *
 * List all available AI providers with their models and availability status.
 *
 * Requires super admin access (system configuration).
 * By default, returns cached models from SystemSettings. Set force_refresh=true to fetch fresh data from AWS.
 */
export const listProviders = <ThrowOnError extends boolean = false>(options?: Options<ListProvidersData, ThrowOnError>): RequestResult<ListProvidersResponses, ListProvidersErrors, ThrowOnError> => (options?.client ?? client).get<ListProvidersResponses, ListProvidersErrors, ThrowOnError>({ url: '/api/ai/providers', ...options });

/**
 * Generate Content
 *
 * Generate AI content using the specified or default provider.
 *
 * Requires super admin access (general-purpose AI generation).
 */
export const generateContent = <ThrowOnError extends boolean = false>(options: Options<GenerateContentData, ThrowOnError>): RequestResult<GenerateContentResponses, GenerateContentErrors, ThrowOnError> => (options.client ?? client).post<GenerateContentResponses, GenerateContentErrors, ThrowOnError>({
    url: '/api/ai/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Content Stream
 *
 * Generate AI content with streaming response.
 *
 * Requires super admin access (general-purpose AI streaming).
 */
export const generateContentStream = <ThrowOnError extends boolean = false>(options: Options<GenerateContentStreamData, ThrowOnError>): RequestResult<GenerateContentStreamResponses, GenerateContentStreamErrors, ThrowOnError> => (options.client ?? client).post<GenerateContentStreamResponses, GenerateContentStreamErrors, ThrowOnError>({
    url: '/api/ai/generate/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Provider Models
 *
 * Get available models for a specific provider.
 *
 * Requires super admin access (system configuration).
 * By default, returns cached models from SystemSettings. Set force_refresh=true to fetch fresh data from AWS.
 * Also caches the models list in SystemSettings for future reference.
 */
export const getProviderModels = <ThrowOnError extends boolean = false>(options: Options<GetProviderModelsData, ThrowOnError>): RequestResult<GetProviderModelsResponses, GetProviderModelsErrors, ThrowOnError> => (options.client ?? client).get<GetProviderModelsResponses, GetProviderModelsErrors, ThrowOnError>({ url: '/api/ai/providers/{provider_name}/models', ...options });

/**
 * Ai Health Check
 *
 * Health check for AI services.
 *
 * Requires super admin access (operational monitoring).
 */
export const aiHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<AiHealthCheckData, ThrowOnError>): RequestResult<AiHealthCheckResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AiHealthCheckResponses, unknown, ThrowOnError>({ url: '/api/ai/health', ...options });

/**
 * Chat Stream
 *
 * Generate AI chat response with SSE streaming.
 *
 * Uses conversation history and summary context for context-aware responses.
 */
export const chatStream = <ThrowOnError extends boolean = false>(options: Options<ChatStreamData, ThrowOnError>): RequestResult<ChatStreamResponses, ChatStreamErrors, ThrowOnError> => (options.client ?? client).post<ChatStreamResponses, ChatStreamErrors, ThrowOnError>({
    url: '/api/ai/chat/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear summary chat history
 *
 * Delete all chat messages for an analysis
 */
export const clearSummaryChatHistory = <ThrowOnError extends boolean = false>(options: Options<ClearSummaryChatHistoryData, ThrowOnError>): RequestResult<ClearSummaryChatHistoryResponses, ClearSummaryChatHistoryErrors, ThrowOnError> => (options.client ?? client).delete<ClearSummaryChatHistoryResponses, ClearSummaryChatHistoryErrors, ThrowOnError>({ url: '/api/ai/chat/summary/{analysis_id}/history', ...options });

/**
 * Get summary chat history
 *
 * Get full chat history for an analysis
 */
export const getSummaryChatHistory = <ThrowOnError extends boolean = false>(options: Options<GetSummaryChatHistoryData, ThrowOnError>): RequestResult<GetSummaryChatHistoryResponses, GetSummaryChatHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetSummaryChatHistoryResponses, GetSummaryChatHistoryErrors, ThrowOnError>({ url: '/api/ai/chat/summary/{analysis_id}/history', ...options });

/**
 * Update summary chat tool proposal status
 *
 * Mark an agent tool proposal as applied or dismissed, or persist remaining proposed section content after line-level review
 */
export const updateSummaryToolProposalStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateSummaryToolProposalStatusData, ThrowOnError>): RequestResult<UpdateSummaryToolProposalStatusResponses, UpdateSummaryToolProposalStatusErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSummaryToolProposalStatusResponses, UpdateSummaryToolProposalStatusErrors, ThrowOnError>({
    url: '/api/ai/chat/summary/{analysis_id}/messages/{message_id}/tool-proposal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Implement summary chat tool proposal
 *
 * Generate proposed section updates for a pending agent plan
 */
export const implementSummaryToolProposal = <ThrowOnError extends boolean = false>(options: Options<ImplementSummaryToolProposalData, ThrowOnError>): RequestResult<ImplementSummaryToolProposalResponses, ImplementSummaryToolProposalErrors, ThrowOnError> => (options.client ?? client).post<ImplementSummaryToolProposalResponses, ImplementSummaryToolProposalErrors, ThrowOnError>({ url: '/api/ai/chat/summary/{analysis_id}/messages/{message_id}/implement-tool-proposal', ...options });

/**
 * Accept summary chat tool proposal
 *
 * Commit accepted FlowEdit operations from an apply_resolved_issues plan (filtered by accepted_element_ids)
 */
export const acceptSummaryToolProposal = <ThrowOnError extends boolean = false>(options: Options<AcceptSummaryToolProposalData, ThrowOnError>): RequestResult<AcceptSummaryToolProposalResponses, AcceptSummaryToolProposalErrors, ThrowOnError> => (options.client ?? client).post<AcceptSummaryToolProposalResponses, AcceptSummaryToolProposalErrors, ThrowOnError>({
    url: '/api/ai/chat/summary/{analysis_id}/messages/{message_id}/accept-tool-proposal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
